export const asia = [
  {
    name: {
      common: 'Timor-Leste',
      official: 'Democratic Republic of Timor-Leste',
      nativeName: {
        por: {
          official: 'República Democrática de Timor-Leste',
          common: 'Timor-Leste'
        },
        tet: {
          official: 'Repúblika Demokrátika Timór-Leste',
          common: 'Timór-Leste'
        }
      }
    },
    tld: ['.tl'],
    cca2: 'TL',
    ccn3: '626',
    cca3: 'TLS',
    cioc: 'TLS',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { USD: { name: 'United States dollar', symbol: '$' } },
    idd: { root: '+6', suffixes: ['70'] },
    capital: ['Dili'],
    altSpellings: [
      'TL',
      'East Timor',
      'Democratic Republic of Timor-Leste',
      'República Democrática de Timor-Leste',
      'Repúblika Demokrátika Timór-Leste',
      "Timór Lorosa'e",
      'Timor Lorosae'
    ],
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    languages: { por: 'Portuguese', tet: 'Tetum' },
    translations: {
      ara: {
        official: 'جمهورية تيمور الشرقية الديمقراطية',
        common: 'تيمور الشرقية'
      },
      bre: {
        official: 'Republik demakratel Timor ar Reter',
        common: 'Timor ar Reter'
      },
      ces: {
        official: 'Demokratická republika Východní Timor',
        common: 'Východní Timor'
      },
      cym: {
        official: 'Democratic Republic of Timor-Leste',
        common: 'Timor-Leste'
      },
      deu: {
        official: 'Demokratische Republik Timor-Leste',
        common: 'Osttimor'
      },
      est: {
        official: 'Timor-Leste Demokraatlik Vabariik',
        common: 'Ida-Timor'
      },
      fin: {
        official: 'Itä-Timorin demokraattinen tasavalta',
        common: 'Itä-Timor'
      },
      fra: {
        official: 'République démocratique du Timor oriental',
        common: 'Timor oriental'
      },
      hrv: {
        official: 'Demokratska Republika Timor-Leste',
        common: 'Istočni Timor'
      },
      hun: {
        official: 'Kelet-timori Demokratikus Köztársaság',
        common: 'Kelet-Timor'
      },
      ita: {
        official: 'Repubblica Democratica di Timor Est',
        common: 'Timor Est'
      },
      jpn: { official: '東ティモール民主共和国', common: '東ティモール' },
      kor: { official: '동티모르 민주 공화국', common: '동티모르' },
      nld: {
        official: 'Democratische Republiek Oost-Timor',
        common: 'Oost-Timor'
      },
      per: { official: 'جمهوری دموکراتیک تیمور شرقی', common: 'تیمور شرقی' },
      pol: {
        official: 'Demokratyczna Republika Timoru Wschodniego',
        common: 'Timor Wschodni'
      },
      por: {
        official: 'República Democrática de Timor-Leste',
        common: 'Timor-Leste'
      },
      rus: {
        official: 'Демократическая Республика Тимор -Лешти',
        common: 'Восточный Тимор'
      },
      slk: {
        official: 'Východotimorská demokratická republika',
        common: 'Východný Timor'
      },
      spa: {
        official: 'República Democrática de Timor-Leste',
        common: 'Timor Oriental'
      },
      swe: { official: 'Demokratiska republiken Östtimor', common: 'Östtimor' },
      tur: {
        official: 'Doğu Timor Demokratik Cumhuriyeti',
        common: 'Doğu Timor'
      },
      urd: { official: 'جمہوری جمہوریہ مشرقی تیمور', common: 'مشرقی تیمور' },
      zho: { official: '东帝汶民主共和国', common: '东帝汶' }
    },
    latlng: [-8.83333333, 125.91666666],
    landlocked: false,
    borders: ['IDN'],
    area: 14874.0,
    demonyms: {
      eng: { f: 'East Timorese', m: 'East Timorese' },
      fra: { f: 'Est-timoraise', m: 'Est-timorais' }
    },
    flag: '\uD83C\uDDF9\uD83C\uDDF1',
    maps: {
      googleMaps: 'https://goo.gl/maps/sFqBC9zjgUXPR1iTA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/305142'
    },
    population: 1318442,
    gini: { 2014: 28.7 },
    fifa: 'TLS',
    car: { signs: ['TL'], side: 'left' },
    timezones: ['UTC+09:00'],
    continents: ['Oceania'],
    flags: {
      png: 'https://flagcdn.com/w320/tl.png',
      svg: 'https://flagcdn.com/tl.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-8.58, 125.6] }
  },
  {
    name: {
      common: 'Kuwait',
      official: 'State of Kuwait',
      nativeName: { ara: { official: 'دولة الكويت', common: 'الكويت' } }
    },
    tld: ['.kw'],
    cca2: 'KW',
    ccn3: '414',
    cca3: 'KWT',
    cioc: 'KUW',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { KWD: { name: 'Kuwaiti dinar', symbol: 'د.ك' } },
    idd: { root: '+9', suffixes: ['65'] },
    capital: ['Kuwait City'],
    altSpellings: ['KW', 'State of Kuwait', 'Dawlat al-Kuwait'],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { ara: 'Arabic' },
    translations: {
      ara: { official: 'دولة الكويت', common: 'الكويت' },
      bre: { official: 'Stad Koweit', common: 'Koweit' },
      ces: { official: 'Stát Kuvajt', common: 'Kuvajt' },
      cym: { official: 'State of Kuwait', common: 'Kuwait' },
      deu: { official: 'Staat Kuwait', common: 'Kuwait' },
      est: { official: 'Kuveidi Riik', common: 'Kuveit' },
      fin: { official: 'Kuwaitin valtio', common: 'Kuwait' },
      fra: { official: 'État du Koweït', common: 'Koweït' },
      hrv: { official: 'Država Kuvajt', common: 'Kuvajt' },
      hun: { official: 'Kuvaiti Állam', common: 'Kuvait' },
      ita: { official: 'Stato del Kuwait', common: 'Kuwait' },
      jpn: { official: 'クウェート国', common: 'クウェート' },
      kor: { official: '쿠웨이트국', common: '쿠웨이트' },
      nld: { official: 'Staat Koeweit', common: 'Koeweit' },
      per: { official: 'دولت کویت', common: 'کُویت' },
      pol: { official: 'Państwo Kuwejt', common: 'Kuwejt' },
      por: { official: 'Estado do Kuwait', common: 'Kuwait' },
      rus: { official: 'Государство Кувейт', common: 'Кувейт' },
      slk: { official: 'Kuvajtský štát', common: 'Kuvajt' },
      spa: { official: 'Estado de Kuwait', common: 'Kuwait' },
      swe: { official: 'Staten Kuwait', common: 'Kuwait' },
      tur: { official: 'Kuveyt Devleti', common: 'Kuveyt' },
      urd: { official: 'دولتِ کویت', common: 'کویت' },
      zho: { official: '科威特国', common: '科威特' }
    },
    latlng: [29.5, 45.75],
    landlocked: false,
    borders: ['IRQ', 'SAU'],
    area: 17818.0,
    demonyms: {
      eng: { f: 'Kuwaiti', m: 'Kuwaiti' },
      fra: { f: 'Koweïtienne', m: 'Koweïtien' }
    },
    flag: '\uD83C\uDDF0\uD83C\uDDFC',
    maps: {
      googleMaps: 'https://goo.gl/maps/aqr3aNQjS1BAvksJ7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/305099'
    },
    population: 4270563,
    fifa: 'KUW',
    car: { signs: ['KWT'], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/kw.png',
      svg: 'https://flagcdn.com/kw.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/kw.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/kw.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [29.37, 47.97] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Macau',
      official:
        "Macao Special Administrative Region of the People's Republic of China",
      nativeName: {
        por: {
          official:
            'Região Administrativa Especial de Macau da República Popular da China',
          common: 'Macau'
        },
        zho: { official: '中华人民共和国澳门特别行政区', common: '澳门' }
      }
    },
    tld: ['.mo'],
    cca2: 'MO',
    ccn3: '446',
    cca3: 'MAC',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { MOP: { name: 'Macanese pataca', symbol: 'P' } },
    idd: { root: '+8', suffixes: ['53'] },
    altSpellings: [
      'MO',
      '澳门',
      'Macao',
      "Macao Special Administrative Region of the People's Republic of China",
      '中華人民共和國澳門特別行政區',
      'Região Administrativa Especial de Macau da República Popular da China'
    ],
    region: 'Asia',
    subregion: 'Eastern Asia',
    languages: { por: 'Portuguese', zho: 'Chinese' },
    translations: {
      ara: {
        official: 'منطقة ماكاو الإدارية التابعة لجمهورية الصين الشعبية',
        common: 'ماكاو'
      },
      bre: {
        official: 'Rannvro velestradurel arbennik Makao eus Republik pobl Sina',
        common: 'Makao'
      },
      ces: {
        official: 'Zvláštní správní oblast Čínské lidové republiky Macao',
        common: 'Macao'
      },
      cym: {
        official:
          "Macao Special Administrative Region of the People's Republic of China",
        common: 'Macau'
      },
      deu: {
        official: 'Sonderverwaltungsregion Macau der Volksrepublik China',
        common: 'Macao'
      },
      est: { official: 'Macau erihalduspiirkond', common: 'Macau' },
      fin: {
        official: 'Macaon Kiinan kansantasavallan erityishallintoalue',
        common: 'Macao'
      },
      fra: {
        official:
          'Région administrative spéciale de Macao de la République populaire de Chine',
        common: 'Macao'
      },
      hrv: {
        official: 'Makao Posebnog upravnog područjaNarodne Republike Kine',
        common: 'Makao'
      },
      hun: { official: 'Makaó', common: 'Makaó' },
      ita: {
        official:
          'Macao Regione amministrativa speciale della Repubblica Popolare Cinese',
        common: 'Macao'
      },
      jpn: { official: '中華人民共和国マカオ特別行政区', common: 'マカオ' },
      kor: { official: '중화인민공화국 마카오 특별행정구', common: '마카오' },
      nld: {
        official:
          'Speciale Administratieve Regio Macau van de Volksrepubliek China',
        common: 'Macao'
      },
      per: { official: 'ماکائو', common: 'ماکائو' },
      pol: {
        official:
          'Specjalny Region Administracyjny Chińskiej Republiki Ludowej Makau',
        common: 'Makau'
      },
      por: {
        official:
          'Macau Região Administrativa Especial da República Popular da China',
        common: 'Macau'
      },
      rus: {
        official:
          'Специальный административный район Макао Китайской Народной Республики Китай',
        common: 'Макао'
      },
      slk: {
        official: 'Macao, Špeciàlna administratívna oblasŦ',
        common: 'Macao'
      },
      spa: {
        official:
          'Macao, Región Administrativa Especial de la República Popular China',
        common: 'Macao'
      },
      swe: { official: 'Macao', common: 'Macao' },
      tur: {
        official: 'Çin Halk Cumhuriyeti Makao Özel İdari Bölgesi',
        common: 'Makao'
      },
      urd: {
        official: 'مکاؤ عوامی جمہوریہ چین کا خصوصی انتظامی علاقہ',
        common: 'مکاؤ'
      }
    },
    latlng: [22.16666666, 113.55],
    landlocked: false,
    borders: ['CHN'],
    area: 30.0,
    demonyms: {
      eng: { f: 'Macanese', m: 'Macanese' },
      fra: { f: 'Macanaise', m: 'Macanais' }
    },
    flag: '\uD83C\uDDF2\uD83C\uDDF4',
    maps: {
      googleMaps: 'https://goo.gl/maps/whymRdk3dZFfAAs4A',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1867188'
    },
    population: 649342,
    fifa: 'MAC',
    car: { signs: ['MO'], side: 'left' },
    timezones: ['UTC+08:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/mo.png',
      svg: 'https://flagcdn.com/mo.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/mo.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/mo.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: {}
  },
  {
    name: {
      common: 'Saudi Arabia',
      official: 'Kingdom of Saudi Arabia',
      nativeName: {
        ara: {
          official: 'المملكة العربية السعودية',
          common: 'العربية السعودية'
        }
      }
    },
    tld: ['.sa', '.السعودية'],
    cca2: 'SA',
    ccn3: '682',
    cca3: 'SAU',
    cioc: 'KSA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { SAR: { name: 'Saudi riyal', symbol: 'ر.س' } },
    idd: { root: '+9', suffixes: ['66'] },
    capital: ['Riyadh'],
    altSpellings: [
      'Saudi',
      'SA',
      'Kingdom of Saudi Arabia',
      'Al-Mamlakah al-‘Arabiyyah as-Su‘ūdiyyah'
    ],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { ara: 'Arabic' },
    translations: {
      ara: { official: 'المملكة العربية السعودية', common: 'السعودية' },
      bre: { official: 'Rouantelezh Arabia Saoudat', common: 'Arabia Saoudat' },
      ces: { official: 'Saúdskoarabské království', common: 'Saúdská Arábie' },
      cym: { official: 'Kingdom of Saudi Arabia', common: 'Saudi Arabia' },
      deu: { official: 'Königreich Saudi-Arabien', common: 'Saudi-Arabien' },
      est: { official: 'Saudi Araabia Kuningriik', common: 'Saudi Araabia' },
      fin: { official: 'Saudi-Arabian kuningaskunta', common: 'Saudi-Arabia' },
      fra: { official: "Royaume d'Arabie Saoudite", common: 'Arabie Saoudite' },
      hrv: {
        official: 'Kraljevina Saudijska Arabija',
        common: 'Saudijska Arabija'
      },
      hun: { official: 'Szaúd-Arábia', common: 'Szaúd-Arábia' },
      ita: { official: 'Arabia Saudita', common: 'Arabia Saudita' },
      jpn: { official: 'サウジアラビア王国', common: 'サウジアラビア' },
      kor: { official: '사우디아라비아 왕국', common: '사우디아라비아' },
      nld: {
        official: 'Koninkrijk van Saoedi-Arabië',
        common: 'Saoedi-Arabië'
      },
      per: { official: 'پادشاهی عربی سَعودی', common: 'عربستان سعودی' },
      pol: {
        official: 'Królestwo Arabii Saudyjskiej',
        common: 'Arabia Saudyjska'
      },
      por: { official: 'Reino da Arábia Saudita', common: 'Arábia Saudita' },
      rus: {
        official: 'Королевство Саудовская Аравия',
        common: 'Саудовская Аравия'
      },
      slk: { official: 'Saudskoarabské kráľovstvo', common: 'Saudská Arábia' },
      spa: { official: 'Reino de Arabia Saudita', common: 'Arabia Saudí' },
      swe: { official: 'Kungadömet Saudiarabien', common: 'Saudiarabien' },
      tur: { official: 'Suudi Arabistan Krallığı', common: 'Suudi Arabistan' },
      urd: { official: 'مملکتِ سعودی عرب', common: 'سعودی عرب' },
      zho: { official: '沙特阿拉伯王国', common: '沙特阿拉伯' }
    },
    latlng: [25.0, 45.0],
    landlocked: false,
    borders: ['IRQ', 'JOR', 'KWT', 'OMN', 'QAT', 'ARE', 'YEM'],
    area: 2149690.0,
    demonyms: {
      eng: { f: 'Saudi Arabian', m: 'Saudi Arabian' },
      fra: { f: 'Saoudienne', m: 'Saoudien' }
    },
    flag: '\uD83C\uDDF8\uD83C\uDDE6',
    maps: {
      googleMaps: 'https://goo.gl/maps/5PSjvdJ1AyaLFRrG9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/307584'
    },
    population: 34813867,
    fifa: 'KSA',
    car: { signs: ['SA'], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/sa.png',
      svg: 'https://flagcdn.com/sa.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/sa.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/sa.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [24.65, 46.7] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Georgia',
      official: 'Georgia',
      nativeName: { kat: { official: 'საქართველო', common: 'საქართველო' } }
    },
    tld: ['.ge'],
    cca2: 'GE',
    ccn3: '268',
    cca3: 'GEO',
    cioc: 'GEO',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { GEL: { name: 'lari', symbol: '₾' } },
    idd: { root: '+9', suffixes: ['95'] },
    capital: ['Tbilisi'],
    altSpellings: ['GE', 'Sakartvelo'],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { kat: 'Georgian' },
    translations: {
      ara: { official: 'جورجيا', common: 'جورجيا' },
      bre: { official: 'Republik Jorjia', common: 'Jorjia' },
      ces: { official: 'Gruzie', common: 'Gruzie' },
      cym: { official: 'Georgia', common: 'Georgia' },
      deu: { official: 'Georgien', common: 'Georgien' },
      est: { official: 'Gruusia', common: 'Gruusia' },
      fin: { official: 'Georgia', common: 'Georgia' },
      fra: { official: 'République de Géorgie', common: 'Géorgie' },
      hrv: { official: 'Gruzija', common: 'Gruzija' },
      hun: { official: 'Grúzia', common: 'Grúzia' },
      ita: { official: 'Georgia', common: 'Georgia' },
      jpn: { official: 'グルジア', common: 'グルジア' },
      kor: { official: '조지아', common: '조지아' },
      nld: { official: 'Georgia', common: 'Georgië' },
      per: { official: 'گرجستان', common: 'گرجستان' },
      pol: { official: 'Gruzja', common: 'Gruzja' },
      por: { official: 'Georgia', common: 'Geórgia' },
      rus: { official: 'Грузия', common: 'Грузия' },
      slk: { official: 'Gruzínsko', common: 'Gruzínsko' },
      spa: { official: 'Georgia', common: 'Georgia' },
      swe: { official: 'Georgien', common: 'Georgien' },
      tur: { official: 'Gürcistan', common: 'Gürcistan' },
      urd: { official: 'جارجیا', common: 'جارجیا' },
      zho: { official: '格鲁吉亚', common: '格鲁吉亚' }
    },
    latlng: [42.0, 43.5],
    landlocked: false,
    borders: ['ARM', 'AZE', 'RUS', 'TUR'],
    area: 69700.0,
    demonyms: {
      eng: { f: 'Georgian', m: 'Georgian' },
      fra: { f: 'Géorgienne', m: 'Géorgien' }
    },
    flag: '\uD83C\uDDEC\uD83C\uDDEA',
    maps: {
      googleMaps: 'https://goo.gl/maps/bvCaGBePR1ZEDK5cA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/28699'
    },
    population: 3714000,
    gini: { 2019: 35.9 },
    fifa: 'GEO',
    car: { signs: ['GE'], side: 'right' },
    timezones: ['UTC-04:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/ge.png',
      svg: 'https://flagcdn.com/ge.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ge.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ge.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [41.68, 44.83] },
    postalCode: { format: '####', regex: '^(\\d{4})$' }
  },
  {
    name: {
      common: 'Lebanon',
      official: 'Lebanese Republic',
      nativeName: {
        ara: { official: 'الجمهورية اللبنانية', common: 'لبنان' },
        fra: { official: 'République libanaise', common: 'Liban' }
      }
    },
    tld: ['.lb'],
    cca2: 'LB',
    ccn3: '422',
    cca3: 'LBN',
    cioc: 'LBN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { LBP: { name: 'Lebanese pound', symbol: 'ل.ل' } },
    idd: { root: '+9', suffixes: ['61'] },
    capital: ['Beirut'],
    altSpellings: ['LB', 'Lebanese Republic', 'Al-Jumhūrīyah Al-Libnānīyah'],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { ara: 'Arabic', fra: 'French' },
    translations: {
      ara: { official: 'الجمهورية اللبنانية', common: 'لبنان' },
      bre: { official: 'Republik Liban', common: 'Liban' },
      ces: { official: 'Libanonská republika', common: 'Libanon' },
      cym: { official: 'Lebanese Republic', common: 'Lebanon' },
      deu: { official: 'Libanesische Republik', common: 'Libanon' },
      est: { official: 'Liibanoni Vabariik', common: 'Liibanon' },
      fin: { official: 'Libanonin tasavalta', common: 'Libanon' },
      fra: { official: 'République libanaise', common: 'Liban' },
      hrv: { official: 'Libanonska Republika', common: 'Libanon' },
      hun: { official: 'Libanoni Köztársaság', common: 'Libanon' },
      ita: { official: 'Repubblica libanese', common: 'Libano' },
      jpn: { official: 'レバノン共和国', common: 'レバノン' },
      kor: { official: '레바논 공화국', common: '레바논' },
      nld: { official: 'Libanese Republiek', common: 'Libanon' },
      per: { official: 'جمهوری لبنان', common: 'لبنان' },
      pol: { official: 'Republika Libańska', common: 'Liban' },
      por: { official: 'República Libanesa', common: 'Líbano' },
      rus: { official: 'Ливанская Республика', common: 'Ливан' },
      slk: { official: 'Libanonská republika', common: 'Libanon' },
      spa: { official: 'República Libanesa', common: 'Líbano' },
      swe: { official: 'Republiken Libanon', common: 'Libanon' },
      tur: { official: 'Lübnan Cumhuriyeti', common: 'Lübnan' },
      urd: { official: 'جمہوریہ لبنان', common: 'لبنان' },
      zho: { official: '黎巴嫩共和国', common: '黎巴嫩' }
    },
    latlng: [33.83333333, 35.83333333],
    landlocked: false,
    borders: ['ISR', 'SYR'],
    area: 10452.0,
    demonyms: {
      eng: { f: 'Lebanese', m: 'Lebanese' },
      fra: { f: 'Libanaise', m: 'Libanais' }
    },
    flag: '\uD83C\uDDF1\uD83C\uDDE7',
    maps: {
      googleMaps: 'https://goo.gl/maps/Sz5VCU8UFBqMyTdc9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/184843'
    },
    population: 6825442,
    gini: { 2011: 31.8 },
    fifa: 'LBN',
    car: { signs: ['RL'], side: 'right' },
    timezones: ['UTC+02:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/lb.png',
      svg: 'https://flagcdn.com/lb.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/lb.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/lb.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [33.87, 35.5] },
    postalCode: { format: '#### ####|####', regex: '^(\\d{4}(\\d{4})?)$' }
  },
  {
    name: {
      common: 'Afghanistan',
      official: 'Islamic Republic of Afghanistan',
      nativeName: {
        prs: { official: 'جمهوری اسلامی افغانستان', common: 'افغانستان' },
        pus: { official: 'د افغانستان اسلامي جمهوریت', common: 'افغانستان' },
        tuk: { official: 'Owganystan Yslam Respublikasy', common: 'Owganystan' }
      }
    },
    tld: ['.af'],
    cca2: 'AF',
    ccn3: '004',
    cca3: 'AFG',
    cioc: 'AFG',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { AFN: { name: 'Afghan afghani', symbol: '؋' } },
    idd: { root: '+9', suffixes: ['3'] },
    capital: ['Kabul'],
    altSpellings: ['AF', 'Afġānistān'],
    region: 'Asia',
    subregion: 'Southern Asia',
    languages: { prs: 'Dari', pus: 'Pashto', tuk: 'Turkmen' },
    translations: {
      ara: { official: 'جمهورية أففانستان الإسلامية', common: 'أفغانستان' },
      bre: { official: 'Republik Islamek Afghanistan', common: 'Afghanistan' },
      ces: { official: 'Afghánská islámská republika', common: 'Afghánistán' },
      cym: {
        official: 'Gweriniaeth Islamaidd Affganistan',
        common: 'Affganistan'
      },
      deu: {
        official: 'Islamische Republik Afghanistan',
        common: 'Afghanistan'
      },
      est: { official: 'Afganistani Islamivabariik', common: 'Afganistan' },
      fin: {
        official: 'Afganistanin islamilainen tasavalta',
        common: 'Afganistan'
      },
      fra: {
        official: "République islamique d'Afghanistan",
        common: 'Afghanistan'
      },
      hrv: { official: 'Islamska Republika Afganistan', common: 'Afganistan' },
      hun: {
        official: 'Afganisztáni Iszlám Köztársaság',
        common: 'Afganisztán'
      },
      ita: {
        official: "Repubblica islamica dell'Afghanistan",
        common: 'Afghanistan'
      },
      jpn: {
        official: 'アフガニスタン·イスラム共和国',
        common: 'アフガニスタン'
      },
      kor: { official: '아프가니스탄 이슬람 공화국', common: '아프가니스탄' },
      nld: {
        official: 'Islamitische Republiek Afghanistan',
        common: 'Afghanistan'
      },
      per: { official: 'جمهوری اسلامی افغانستان', common: 'افغانستان' },
      pol: { official: 'Islamska Republika Afganistanu', common: 'Afganistan' },
      por: {
        official: 'República Islâmica do Afeganistão',
        common: 'Afeganistão'
      },
      rus: {
        official: 'Исламская Республика Афганистан',
        common: 'Афганистан'
      },
      slk: { official: 'Afgánsky islamský štát', common: 'Afganistan' },
      spa: {
        official: 'República Islámica de Afganistán',
        common: 'Afganistán'
      },
      swe: {
        official: 'Islamiska republiken Afghanistan',
        common: 'Afghanistan'
      },
      tur: { official: 'Afganistan İslam Cumhuriyeti', common: 'Afganistan' },
      urd: { official: 'اسلامی جمہوریہ افغانستان', common: 'افغانستان' },
      zho: { official: '阿富汗伊斯兰共和国', common: '阿富汗' }
    },
    latlng: [33.0, 65.0],
    landlocked: true,
    borders: ['IRN', 'PAK', 'TKM', 'UZB', 'TJK', 'CHN'],
    area: 652230.0,
    demonyms: {
      eng: { f: 'Afghan', m: 'Afghan' },
      fra: { f: 'Afghane', m: 'Afghan' }
    },
    flag: '\uD83C\uDDE6\uD83C\uDDEB',
    maps: {
      googleMaps: 'https://goo.gl/maps/BXBGw7yUUFknCfva9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/303427'
    },
    population: 40218234,
    fifa: 'AFG',
    car: { signs: ['AFG'], side: 'right' },
    timezones: ['UTC+04:30'],
    continents: ['Asia'],
    flags: {
      png: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_the_Taliban.svg/320px-Flag_of_the_Taliban.svg.png',
      svg: 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_the_Taliban.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/af.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/af.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [34.52, 69.18] }
  },
  {
    name: {
      common: 'Azerbaijan',
      official: 'Republic of Azerbaijan',
      nativeName: {
        aze: { official: 'Azərbaycan Respublikası', common: 'Azərbaycan' },
        rus: { official: 'Азербайджанская Республика', common: 'Азербайджан' }
      }
    },
    tld: ['.az'],
    cca2: 'AZ',
    ccn3: '031',
    cca3: 'AZE',
    cioc: 'AZE',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { AZN: { name: 'Azerbaijani manat', symbol: '₼' } },
    idd: { root: '+9', suffixes: ['94'] },
    capital: ['Baku'],
    altSpellings: ['AZ', 'Republic of Azerbaijan', 'Azərbaycan Respublikası'],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { aze: 'Azerbaijani', rus: 'Russian' },
    translations: {
      ara: { official: 'جمهورية أذربيجان', common: 'أذربيجان' },
      bre: { official: 'Republik Azerbaidjan', common: 'Azerbaidjan' },
      ces: { official: 'Ázerbájdžánská republika', common: 'Ázerbájdžán' },
      cym: { official: 'Gweriniaeth Aserbaijan', common: 'Aserbaijan' },
      deu: { official: 'Republik Aserbaidschan', common: 'Aserbaidschan' },
      est: { official: 'Aserbaidžaani Vabariik', common: 'Aserbaidžaan' },
      fin: { official: 'Azerbaidzanin tasavalta', common: 'Azerbaidzan' },
      fra: { official: "République d'Azerbaïdjan", common: 'Azerbaïdjan' },
      hrv: { official: 'Republika Azerbajdžan', common: 'Azerbajdžan' },
      hun: { official: 'Azerbajdzsán', common: 'Azerbajdzsán' },
      ita: { official: "Repubblica dell'Azerbaigian", common: 'Azerbaijan' },
      jpn: { official: 'アゼルバイジャン共和国', common: 'アゼルバイジャン' },
      kor: { official: '아제르바이잔 공화국', common: '아제르바이잔' },
      nld: { official: 'Republiek Azerbeidzjan', common: 'Azerbeidzjan' },
      per: { official: 'جمهوری آذربایجان', common: 'جمهوری آذربایجان' },
      pol: { official: 'Republika Azerbejdżanu', common: 'Azerbejdżan' },
      por: { official: 'República do Azerbaijão', common: 'Azerbeijão' },
      rus: { official: 'Азербайджанская Республика', common: 'Азербайджан' },
      slk: { official: 'Azerbajǆanská republika', common: 'AzerbajǇan' },
      spa: { official: 'República de Azerbaiyán', common: 'Azerbaiyán' },
      swe: { official: 'Republiken Azerbajdzjan', common: 'Azerbajdzjan' },
      tur: { official: 'Azerbaycan Cumhuriyeti', common: 'Azerbaycan' },
      urd: { official: 'جمہوریہ آذربائیجان', common: 'آذربائیجان' },
      zho: { official: '阿塞拜疆共和国', common: '阿塞拜疆' }
    },
    latlng: [40.5, 47.5],
    landlocked: true,
    borders: ['ARM', 'GEO', 'IRN', 'RUS', 'TUR'],
    area: 86600.0,
    demonyms: {
      eng: { f: 'Azerbaijani', m: 'Azerbaijani' },
      fra: { f: 'Azerbaïdjanaise', m: 'Azerbaïdjanais' }
    },
    flag: '\uD83C\uDDE6\uD83C\uDDFF',
    maps: {
      googleMaps: 'https://goo.gl/maps/az3Zz7ar2aoB9AUc6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/364110'
    },
    population: 10110116,
    gini: { 2005: 26.6 },
    fifa: 'AZE',
    car: { signs: ['AZ'], side: 'right' },
    timezones: ['UTC+04:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/az.png',
      svg: 'https://flagcdn.com/az.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/az.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/az.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [40.38, 49.87] },
    postalCode: { format: 'AZ ####', regex: '^(?:AZ)*(\\d{4})$' }
  },
  {
    name: {
      common: 'Brunei',
      official: 'Nation of Brunei, Abode of Peace',
      nativeName: {
        msa: {
          official: 'Nation of Brunei, Abode Damai',
          common: 'Negara Brunei Darussalam'
        }
      }
    },
    tld: ['.bn'],
    cca2: 'BN',
    ccn3: '096',
    cca3: 'BRN',
    cioc: 'BRU',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: {
      BND: { name: 'Brunei dollar', symbol: '$' },
      SGD: { name: 'Singapore dollar', symbol: '$' }
    },
    idd: { root: '+6', suffixes: ['73'] },
    capital: ['Bandar Seri Begawan'],
    altSpellings: [
      'BN',
      'Brunei Darussalam',
      'Nation of Brunei',
      'the Abode of Peace'
    ],
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    languages: { msa: 'Malay' },
    translations: {
      ara: { official: 'بروناي دار السلام', common: 'بروناي' },
      bre: { official: 'Stad Brunei Darussalam', common: 'Brunei' },
      ces: { official: 'Sultanát Brunej', common: 'Brunej' },
      cym: { official: 'Teyrnas Brwnei', common: 'Brunei' },
      deu: { official: 'Sultanat Brunei Darussalam', common: 'Brunei' },
      est: { official: 'Brunei Darussalami Riik', common: 'Brunei' },
      fin: { official: 'Brunei Darussalamin valtio', common: 'Brunei' },
      fra: { official: 'État de Brunei Darussalam', common: 'Brunei' },
      hrv: { official: 'Nacija od Bruneja, Kuću Mira', common: 'Brunej' },
      hun: { official: 'Brunei Szultanátus', common: 'Brunei' },
      ita: {
        official: 'Nazione di Brunei, Dimora della Pace',
        common: 'Brunei'
      },
      jpn: {
        official: 'ブルネイ、平和の精舎の国家',
        common: 'ブルネイ・ダルサラーム'
      },
      kor: { official: '브루나이 다루살람국', common: '브루나이' },
      nld: {
        official: 'Natie van Brunei, de verblijfplaats van de Vrede',
        common: 'Brunei'
      },
      per: { official: 'برونئی سرای صلح', common: 'برونئی' },
      pol: { official: 'Państwo Brunei Darussalam', common: 'Brunei' },
      por: { official: 'Nação do Brunei, Morada da Paz', common: 'Brunei' },
      rus: { official: 'Нация Бруней, обитель мира', common: 'Бруней' },
      slk: { official: 'Brunejský sultanât', common: 'Brunej' },
      spa: { official: 'Nación de Brunei, Morada de la Paz', common: 'Brunei' },
      swe: { official: 'Brunei Darussalam', common: 'Brunei' },
      tur: { official: 'Brunei Barış Ülkesi Devleti', common: 'Brunei' },
      urd: { official: 'ریاستِ برونائی دارالسلام', common: 'برونائی' },
      zho: { official: '文莱和平之国', common: '文莱' }
    },
    latlng: [4.5, 114.66666666],
    landlocked: false,
    borders: ['MYS'],
    area: 5765.0,
    demonyms: {
      eng: { f: 'Bruneian', m: 'Bruneian' },
      fra: { f: 'Brunéienne', m: 'Brunéien' }
    },
    flag: '\uD83C\uDDE7\uD83C\uDDF3',
    maps: {
      googleMaps: 'https://goo.gl/maps/4jb4CqBXhr8vNh579',
      openStreetMaps: 'https://www.openstreetmap.org/relation/2103120'
    },
    population: 437483,
    fifa: 'BRU',
    car: { signs: ['BRU'], side: 'left' },
    timezones: ['UTC+08:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/bn.png',
      svg: 'https://flagcdn.com/bn.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/bn.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/bn.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [4.88, 114.93] },
    postalCode: { format: '@@####', regex: '^([A-Z]{2}\\d{4})$' }
  },
  {
    name: {
      common: 'Bhutan',
      official: 'Kingdom of Bhutan',
      nativeName: { dzo: { official: 'འབྲུག་རྒྱལ་ཁབ་', common: 'འབྲུག་ཡུལ་' } }
    },
    tld: ['.bt'],
    cca2: 'BT',
    ccn3: '064',
    cca3: 'BTN',
    cioc: 'BHU',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: {
      BTN: { name: 'Bhutanese ngultrum', symbol: 'Nu.' },
      INR: { name: 'Indian rupee', symbol: '₹' }
    },
    idd: { root: '+9', suffixes: ['75'] },
    capital: ['Thimphu'],
    altSpellings: ['BT', 'Kingdom of Bhutan'],
    region: 'Asia',
    subregion: 'Southern Asia',
    languages: { dzo: 'Dzongkha' },
    translations: {
      ara: { official: 'مملكة بوتان', common: 'بوتان' },
      bre: { official: 'Rouantelezh Bhoutan', common: 'Bhoutan' },
      ces: { official: 'Bhútánské království', common: 'Bhútán' },
      cym: { official: 'Teyrnas Bhwtan', common: 'Bhwtan' },
      deu: { official: 'Königreich Bhutan', common: 'Bhutan' },
      est: { official: 'Bhutani Kuningriik', common: 'Bhutan' },
      fin: { official: 'Bhutanin kuningaskunta', common: 'Bhutan' },
      fra: { official: 'Royaume du Bhoutan', common: 'Bhoutan' },
      hrv: { official: 'Kraljevina Butan', common: 'Butan' },
      hun: { official: 'Bhutáni Királyság', common: 'Bhután' },
      ita: { official: 'Regno del Bhutan', common: 'Bhutan' },
      jpn: { official: 'ブータン王国', common: 'ブータン' },
      kor: { official: '부탄 왕국', common: '부탄' },
      nld: { official: 'Koninkrijk Bhutan', common: 'Bhutan' },
      per: { official: 'پادشاهی بوتان', common: 'بوتان' },
      pol: { official: 'Bhutan', common: 'Bhutan' },
      por: { official: 'Reino do Butão', common: 'Butão' },
      rus: { official: 'Королевство Бутан', common: 'Бутан' },
      slk: { official: 'Bhutánske krâľovstvo', common: 'Bhután' },
      spa: { official: 'Reino de Bután', common: 'Bután' },
      swe: { official: 'Konungariket Bhutan', common: 'Bhutan' },
      tur: { official: 'Butan Krallığı', common: 'Butan' },
      urd: { official: 'سلطنت بھوٹان', common: 'بھوٹان' },
      zho: { official: '不丹王国', common: '不丹' }
    },
    latlng: [27.5, 90.5],
    landlocked: true,
    borders: ['CHN', 'IND'],
    area: 38394.0,
    demonyms: {
      eng: { f: 'Bhutanese', m: 'Bhutanese' },
      fra: { f: 'Bhoutanaise', m: 'Bhoutanais' }
    },
    flag: '\uD83C\uDDE7\uD83C\uDDF9',
    maps: {
      googleMaps: 'https://goo.gl/maps/VEfXXBftTFLUpNgp8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/184629'
    },
    population: 771612,
    gini: { 2017: 37.4 },
    fifa: 'BHU',
    car: { signs: ['BHT'], side: 'left' },
    timezones: ['UTC+06:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/bt.png',
      svg: 'https://flagcdn.com/bt.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/bt.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/bt.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [27.47, 89.63] }
  },
  {
    name: {
      common: 'Jordan',
      official: 'Hashemite Kingdom of Jordan',
      nativeName: {
        ara: { official: 'المملكة الأردنية الهاشمية', common: 'الأردن' }
      }
    },
    tld: ['.jo', 'الاردن.'],
    cca2: 'JO',
    ccn3: '400',
    cca3: 'JOR',
    cioc: 'JOR',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { JOD: { name: 'Jordanian dinar', symbol: 'د.ا' } },
    idd: { root: '+9', suffixes: ['62'] },
    capital: ['Amman'],
    altSpellings: [
      'JO',
      'Hashemite Kingdom of Jordan',
      'al-Mamlakah al-Urdunīyah al-Hāshimīyah'
    ],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { ara: 'Arabic' },
    translations: {
      ara: { official: 'المملكة الأردنية الهاشمية', common: 'الأردن' },
      bre: { official: 'Rouantelezh hachemit Jordania', common: 'Jordania' },
      ces: { official: 'Jordánské hášimovské království', common: 'Jordánsko' },
      cym: { official: 'Hashemite Kingdom of Jordan', common: 'Jordan' },
      deu: {
        official: 'Haschemitisches Königreich Jordanien',
        common: 'Jordanien'
      },
      est: { official: 'Jordaania Hašimiidi Kuningriik', common: 'Jordaania' },
      fin: {
        official: 'Jordanian hašemiittinen kunigaskunta',
        common: 'Jordania'
      },
      fra: { official: 'Royaume hachémite de Jordanie', common: 'Jordanie' },
      hrv: { official: 'Hašemitske Kraljevine Jordan', common: 'Jordan' },
      hun: { official: 'Jordánia', common: 'Jordánia' },
      ita: { official: 'Regno hascemita di Giordania', common: 'Giordania' },
      jpn: { official: 'ヨルダン·ハシミテ王国', common: 'ヨルダン' },
      kor: { official: '요르단 하심 왕국', common: '요르단' },
      nld: { official: 'Hasjemitisch Koninkrijk Jordanië', common: 'Jordanië' },
      per: { official: 'پادشاهی اُردُن هاشمی', common: 'اردن' },
      pol: {
        official: 'Jordańskie Królestwo Haszymidzkie',
        common: 'Jordania'
      },
      por: { official: 'Reino Hachemita da Jordânia', common: 'Jordânia' },
      rus: {
        official: 'Иорданского Хашимитского Королевства',
        common: 'Иордания'
      },
      slk: { official: 'Jordánske hášimovské kráľovstvo', common: 'Jordánsko' },
      spa: { official: 'Reino Hachemita de Jordania', common: 'Jordania' },
      swe: {
        official: 'Hashimitiska kungadömet Jordanien',
        common: 'Jordanien'
      },
      tur: { official: 'Ürdün Hâşimi Krallığı', common: 'Ürdün' },
      urd: { official: 'ھاشمی مملکتِ اردن', common: 'اردن' },
      zho: { official: '约旦哈希姆王国', common: '约旦' }
    },
    latlng: [31.0, 36.0],
    landlocked: false,
    borders: ['IRQ', 'ISR', 'PSE', 'SAU', 'SYR'],
    area: 89342.0,
    demonyms: {
      eng: { f: 'Jordanian', m: 'Jordanian' },
      fra: { f: 'Jordanienne', m: 'Jordanien' }
    },
    flag: '\uD83C\uDDEF\uD83C\uDDF4',
    maps: {
      googleMaps: 'https://goo.gl/maps/ko1dzSDKg8Gsi9A98',
      openStreetMaps: 'https://www.openstreetmap.org/relation/184818'
    },
    population: 10203140,
    gini: { 2010: 33.7 },
    fifa: 'JOR',
    car: { signs: ['HKJ'], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/jo.png',
      svg: 'https://flagcdn.com/jo.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/jo.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/jo.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [31.95, 35.93] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'China',
      official: "People's Republic of China",
      nativeName: { zho: { official: '中华人民共和国', common: '中国' } }
    },
    tld: ['.cn', '.中国', '.中國', '.公司', '.网络'],
    cca2: 'CN',
    ccn3: '156',
    cca3: 'CHN',
    cioc: 'CHN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { CNY: { name: 'Chinese yuan', symbol: '¥' } },
    idd: { root: '+8', suffixes: ['6'] },
    capital: ['Beijing'],
    altSpellings: [
      'CN',
      'Zhōngguó',
      'Zhongguo',
      'Zhonghua',
      "People's Republic of China",
      '中华人民共和国',
      'Zhōnghuá Rénmín Gònghéguó'
    ],
    region: 'Asia',
    subregion: 'Eastern Asia',
    languages: { zho: 'Chinese' },
    translations: {
      ara: { official: 'جمهورية الصين الشعبية', common: 'الصين' },
      bre: { official: 'Republik Pobl Sina', common: 'Sina' },
      ces: { official: 'Čínská lidová republika', common: 'Čína' },
      cym: { official: 'Gweriniaeth Pobl Tsieina', common: 'Tsieina' },
      deu: { official: 'Volksrepublik China', common: 'China' },
      est: { official: 'Hiina Rahvavabariik', common: 'Hiina' },
      fin: { official: 'Kiinan kansantasavalta', common: 'Kiina' },
      fra: { official: 'République populaire de Chine', common: 'Chine' },
      hrv: { official: 'Narodna Republika Kina', common: 'Kina' },
      hun: { official: 'Kínai Népköztársaság', common: 'Kína' },
      ita: { official: 'Repubblica popolare cinese', common: 'Cina' },
      jpn: { official: '中華人民共和国', common: '中国' },
      kor: { official: '중화인민공화국', common: '중국' },
      nld: { official: 'Volksrepubliek China', common: 'China' },
      per: { official: 'جمهوری خلق چین', common: 'چین' },
      pol: { official: 'Chińska Republika Ludowa', common: 'Chiny' },
      por: { official: 'República Popular da China', common: 'China' },
      rus: { official: 'Народная Республика Китай', common: 'Китай' },
      slk: { official: 'Čínska ľudová republika', common: 'Čína' },
      spa: { official: 'República Popular de China', common: 'China' },
      swe: { official: 'Folkrepubliken Kina', common: 'Kina' },
      tur: { official: 'Çin Halk Cumhuriyeti', common: 'Çin' },
      urd: { official: 'عوامی جمہوریہ چین', common: 'چین' }
    },
    latlng: [35.0, 105.0],
    landlocked: false,
    borders: [
      'AFG',
      'BTN',
      'MMR',
      'HKG',
      'IND',
      'KAZ',
      'NPL',
      'PRK',
      'KGZ',
      'LAO',
      'MAC',
      'MNG',
      'PAK',
      'RUS',
      'TJK',
      'VNM'
    ],
    area: 9706961.0,
    demonyms: {
      eng: { f: 'Chinese', m: 'Chinese' },
      fra: { f: 'Chinoise', m: 'Chinois' }
    },
    flag: '\uD83C\uDDE8\uD83C\uDDF3',
    maps: {
      googleMaps: 'https://goo.gl/maps/p9qC6vgiFRRXzvGi7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/270056'
    },
    population: 1402112000,
    gini: { 2016: 38.5 },
    fifa: 'CHN',
    car: { signs: ['RC'], side: 'right' },
    timezones: ['UTC+08:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/cn.png',
      svg: 'https://flagcdn.com/cn.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/cn.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/cn.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [39.92, 116.38] },
    postalCode: { format: '######', regex: '^(\\d{6})$' }
  },
  {
    name: {
      common: 'Iraq',
      official: 'Republic of Iraq',
      nativeName: {
        ara: { official: 'جمهورية العراق', common: 'العراق' },
        arc: { official: 'ܩܘܼܛܢܵܐ ܐܝܼܪܲܩ', common: 'ܩܘܼܛܢܵܐ' },
        ckb: { official: 'کۆماری عێراق', common: 'کۆماری' }
      }
    },
    tld: ['.iq'],
    cca2: 'IQ',
    ccn3: '368',
    cca3: 'IRQ',
    cioc: 'IRQ',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { IQD: { name: 'Iraqi dinar', symbol: 'ع.د' } },
    idd: { root: '+9', suffixes: ['64'] },
    capital: ['Baghdad'],
    altSpellings: ['IQ', 'Republic of Iraq', 'Jumhūriyyat al-‘Irāq'],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { ara: 'Arabic', arc: 'Aramaic', ckb: 'Sorani' },
    translations: {
      ara: { official: 'جمهورية العراق', common: 'العراق' },
      bre: { official: 'Republik Irak', common: 'Irak' },
      ces: { official: 'Irácká republika', common: 'Irák' },
      cym: { official: 'Republic of Iraq', common: 'Iraq' },
      deu: { official: 'Republik Irak', common: 'Irak' },
      est: { official: 'Iraagi Vabariik', common: 'Iraak' },
      fin: { official: 'Irakin tasavalta', common: 'Irak' },
      fra: { official: "République d'Irak", common: 'Irak' },
      hrv: { official: 'Republika Irak', common: 'Irak' },
      hun: { official: 'Iraki Köztársaság', common: 'Irak' },
      ita: { official: "Repubblica dell'Iraq", common: 'Iraq' },
      jpn: { official: 'イラク共和国', common: 'イラク' },
      kor: { official: '이라크 공화국', common: '이라크' },
      nld: { official: 'Republiek Irak', common: 'Irak' },
      per: { official: 'جمهوری عراق', common: 'عراق' },
      pol: { official: 'Republika Iraku', common: 'Irak' },
      por: { official: 'República do Iraque', common: 'Iraque' },
      rus: { official: 'Республика Ирак', common: 'Ирак' },
      slk: { official: 'Iracká republika', common: 'Irak' },
      spa: { official: 'República de Irak', common: 'Irak' },
      swe: { official: 'Republiken Irak', common: 'Irak' },
      tur: { official: 'Irak Cumhuriyeti', common: 'Irak' },
      urd: { official: 'جمہوریہ عراق', common: 'عراق' },
      zho: { official: '伊拉克共和国', common: '伊拉克' }
    },
    latlng: [33.0, 44.0],
    landlocked: false,
    borders: ['IRN', 'JOR', 'KWT', 'SAU', 'SYR', 'TUR'],
    area: 438317.0,
    demonyms: {
      eng: { f: 'Iraqi', m: 'Iraqi' },
      fra: { f: 'Irakienne', m: 'Irakien' }
    },
    flag: '\uD83C\uDDEE\uD83C\uDDF6',
    maps: {
      googleMaps: 'https://goo.gl/maps/iL8Bmy1sUCW9fUk18',
      openStreetMaps: 'https://www.openstreetmap.org/relation/304934'
    },
    population: 40222503,
    gini: { 2012: 29.5 },
    fifa: 'IRQ',
    car: { signs: ['IRQ'], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/iq.png',
      svg: 'https://flagcdn.com/iq.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/iq.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/iq.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [33.33, 44.4] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'United Arab Emirates',
      official: 'United Arab Emirates',
      nativeName: {
        ara: {
          official: 'الإمارات العربية المتحدة',
          common: 'دولة الإمارات العربية المتحدة'
        }
      }
    },
    tld: ['.ae', 'امارات.'],
    cca2: 'AE',
    ccn3: '784',
    cca3: 'ARE',
    cioc: 'UAE',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { AED: { name: 'United Arab Emirates dirham', symbol: 'د.إ' } },
    idd: { root: '+9', suffixes: ['71'] },
    capital: ['Abu Dhabi'],
    altSpellings: ['AE', 'UAE', 'Emirates'],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { ara: 'Arabic' },
    translations: {
      ara: {
        official: 'الإمارات العربية المتحدة',
        common: 'دولة الإمارات العربية المتحدة'
      },
      bre: {
        official: 'Emirelezhioù Arab Unanet',
        common: 'Emirelezhioù Arab Unanet'
      },
      ces: {
        official: 'Spojené arabské emiráty',
        common: 'Spojené arabské emiráty'
      },
      cym: { official: 'United Arab Emirates', common: 'United Arab Emirates' },
      deu: {
        official: 'Vereinigte Arabische Emirate',
        common: 'Vereinigte Arabische Emirate'
      },
      est: {
        official: 'Araabia Ühendemiraadid',
        common: 'Araabia Ühendemiraadid'
      },
      fin: {
        official: 'Yhdistyneet arabiemiirikunnat',
        common: 'Arabiemiraatit'
      },
      fra: { official: 'Émirats arabes unis', common: 'Émirats arabes unis' },
      hrv: {
        official: 'Ujedinjeni Arapski Emirati',
        common: 'Ujedinjeni Arapski Emirati'
      },
      hun: {
        official: 'Egyesült Arab Emírségek',
        common: 'Egyesült Arab Emírségek'
      },
      ita: { official: 'Emirati Arabi Uniti', common: 'Emirati Arabi Uniti' },
      jpn: { official: 'アラブ首長国連邦', common: 'アラブ首長国連邦' },
      kor: { official: '아랍 토후국 연방', common: '아랍에미리트' },
      nld: {
        official: 'Verenigde Arabische Emiraten',
        common: 'Verenigde Arabische Emiraten'
      },
      per: { official: 'امارات متحده عربی', common: 'امارات' },
      pol: {
        official: 'Zjednoczone Emiraty Arabskie',
        common: 'Zjednoczone Emiraty Arabskie'
      },
      por: {
        official: 'Emirados Árabes Unidos',
        common: 'Emirados Árabes Unidos'
      },
      rus: {
        official: 'Объединенные Арабские Эмираты',
        common: 'Объединённые Арабские Эмираты'
      },
      slk: {
        official: 'Spojené arabské emiráty',
        common: 'Spojené arabské emiráty'
      },
      spa: {
        official: 'Emiratos Árabes Unidos',
        common: 'Emiratos Árabes Unidos'
      },
      swe: {
        official: 'Förenade Arabemiraten',
        common: 'Förenade Arabemiraten'
      },
      tur: {
        official: 'Birleşik Arap Emirlikleri',
        common: 'Birleşik Arap Emirlikleri'
      },
      urd: { official: 'متحدہ عرب امارات', common: 'متحدہ عرب امارات' },
      zho: { official: '阿拉伯联合酋长国', common: '阿拉伯联合酋长国' }
    },
    latlng: [24.0, 54.0],
    landlocked: false,
    borders: ['OMN', 'SAU'],
    area: 83600.0,
    demonyms: {
      eng: { f: 'Emirati', m: 'Emirati' },
      fra: { f: 'Emirienne', m: 'Emirien' }
    },
    flag: '\uD83C\uDDE6\uD83C\uDDEA',
    maps: {
      googleMaps: 'https://goo.gl/maps/AZZTDA6GzVAnKMVd8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/307763'
    },
    population: 9890400,
    gini: { 2018: 26.0 },
    fifa: 'UAE',
    car: { signs: ['UAE'], side: 'right' },
    timezones: ['UTC+04:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/ae.png',
      svg: 'https://flagcdn.com/ae.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ae.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ae.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [24.47, 54.37] }
  },
  {
    name: {
      common: 'Tajikistan',
      official: 'Republic of Tajikistan',
      nativeName: {
        rus: { official: 'Республика Таджикистан', common: 'Таджикистан' },
        tgk: { official: 'Ҷумҳурии Тоҷикистон', common: 'Тоҷикистон' }
      }
    },
    tld: ['.tj'],
    cca2: 'TJ',
    ccn3: '762',
    cca3: 'TJK',
    cioc: 'TJK',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { TJS: { name: 'Tajikistani somoni', symbol: 'ЅМ' } },
    idd: { root: '+9', suffixes: ['92'] },
    capital: ['Dushanbe'],
    altSpellings: [
      'TJ',
      'Toçikiston',
      'Republic of Tajikistan',
      'Ҷумҳурии Тоҷикистон',
      'Çumhuriyi Toçikiston'
    ],
    region: 'Asia',
    subregion: 'Central Asia',
    languages: { rus: 'Russian', tgk: 'Tajik' },
    translations: {
      ara: { official: 'جمهورية طاجيكستان', common: 'طاجيكستان' },
      bre: { official: 'Republik Tadjikistan', common: 'Tadjikistan' },
      ces: { official: 'Republika Tádžikistán', common: 'Tádžikistán' },
      cym: { official: 'Republic of Tajikistan', common: 'Tajikistan' },
      deu: { official: 'Republik Tadschikistan', common: 'Tadschikistan' },
      est: { official: 'Tadžikistani Vabariik', common: 'Tadžikistan' },
      fin: { official: 'Tadžikistanin tasavalta', common: 'Tadžikistan' },
      fra: { official: 'République du Tadjikistan', common: 'Tadjikistan' },
      hrv: { official: 'Republika Tadžikistan', common: 'Tađikistan' },
      hun: { official: 'Tádzsik Köztársaság', common: 'Tádzsikisztán' },
      ita: { official: 'Repubblica del Tajikistan', common: 'Tagikistan' },
      jpn: { official: 'タジキスタン共和国', common: 'タジキスタン' },
      kor: { official: '타지키스탄 공화국', common: '타지키스탄' },
      nld: { official: 'Tadzjikistan', common: 'Tadzjikistan' },
      per: { official: 'جمهوری تاجیکستان', common: 'تاجیکِستان' },
      pol: { official: 'Republika Tadżykistanu', common: 'Tadżykistan' },
      por: { official: 'República do Tajiquistão', common: 'Tajiquistão' },
      rus: { official: 'Республика Таджикистан', common: 'Таджикистан' },
      slk: { official: 'Taǆická republika', common: 'Taǆikistan' },
      spa: { official: 'República de Tayikistán', common: 'Tayikistán' },
      swe: { official: 'Republiken Tadzjikistan', common: 'Tadzjikistan' },
      tur: { official: 'Tacikistan Cumhuriyeti', common: 'Tacikistan' },
      urd: { official: 'جمہوریہ تاجکستان', common: 'تاجکستان' },
      zho: { official: '塔吉克斯坦共和国', common: '塔吉克斯坦' }
    },
    latlng: [39.0, 71.0],
    landlocked: true,
    borders: ['AFG', 'CHN', 'KGZ', 'UZB'],
    area: 143100.0,
    demonyms: {
      eng: { f: 'Tadzhik', m: 'Tadzhik' },
      fra: { f: 'Tadjike', m: 'Tadjike' }
    },
    flag: '\uD83C\uDDF9\uD83C\uDDEF',
    maps: {
      googleMaps: 'https://goo.gl/maps/8rQgW88jEXijhVb58',
      openStreetMaps: 'https://www.openstreetmap.org/relation/214626'
    },
    population: 9537642,
    gini: { 2015: 34.0 },
    fifa: 'TJK',
    car: { signs: ['TJ'], side: 'right' },
    timezones: ['UTC+05:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/tj.png',
      svg: 'https://flagcdn.com/tj.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/tj.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/tj.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [38.55, 68.77] },
    postalCode: { format: '######', regex: '^(\\d{6})$' }
  },
  {
    name: {
      common: 'Cambodia',
      official: 'Kingdom of Cambodia',
      nativeName: {
        khm: { official: 'ព្រះរាជាណាចក្រកម្ពុជា', common: 'Kâmpŭchéa' }
      }
    },
    tld: ['.kh'],
    cca2: 'KH',
    ccn3: '116',
    cca3: 'KHM',
    cioc: 'CAM',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: {
      KHR: { name: 'Cambodian riel', symbol: '៛' },
      USD: { name: 'United States dollar', symbol: '$' }
    },
    idd: { root: '+8', suffixes: ['55'] },
    capital: ['Phnom Penh'],
    altSpellings: ['KH', 'Kingdom of Cambodia'],
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    languages: { khm: 'Khmer' },
    translations: {
      ara: { official: 'مملكة كمبوديا', common: 'كمبوديا' },
      bre: { official: 'Rouantelezh Kambodja', common: 'Kambodja' },
      ces: { official: 'Kambodžské království', common: 'Kambodža' },
      cym: { official: 'Teyrnas Cambodia', common: 'Cambodia' },
      deu: { official: 'Königreich Kambodscha', common: 'Kambodscha' },
      est: { official: 'Kambodža Kuningriik', common: 'Kambodža' },
      fin: { official: 'Kambodžan kuningaskunta', common: 'Kambodža' },
      fra: { official: 'Royaume du Cambodge', common: 'Cambodge' },
      hrv: { official: 'Kraljevina Kambodža', common: 'Kambodža' },
      hun: { official: 'Kambodzsai Királyság', common: 'Kambodzsa' },
      ita: { official: 'Regno di Cambogia', common: 'Cambogia' },
      jpn: { official: 'カンボジア王国', common: 'カンボジア' },
      kor: { official: '캄보디아 왕국', common: '캄보디아' },
      nld: { official: 'Koninkrijk Cambodja', common: 'Cambodja' },
      per: { official: 'پادشاهی کامبوج', common: 'کامبوج' },
      pol: { official: 'Królestwo Kambodży', common: 'Kambodża' },
      por: { official: 'Reino do Camboja', common: 'Camboja' },
      rus: { official: 'Королевство Камбоджа', common: 'Камбоджа' },
      slk: { official: 'Kamboǆské kráľovstvo', common: 'Kamboǆa' },
      spa: { official: 'Reino de Camboya', common: 'Camboya' },
      swe: { official: 'Konungariket Kambodja', common: 'Kambodja' },
      tur: { official: 'Kamboçya Krallığı', common: 'Kamboçya' },
      urd: { official: 'مملکتِ کمبوڈیا', common: 'کمبوڈیا' },
      zho: { official: '柬埔寨王国', common: '柬埔寨' }
    },
    latlng: [13.0, 105.0],
    landlocked: false,
    borders: ['LAO', 'THA', 'VNM'],
    area: 181035.0,
    demonyms: {
      eng: { f: 'Cambodian', m: 'Cambodian' },
      fra: { f: 'Cambodgienne', m: 'Cambodgien' }
    },
    flag: '\uD83C\uDDF0\uD83C\uDDED',
    maps: {
      googleMaps: 'https://goo.gl/maps/nztQtFSrUXZymJaW8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/49898'
    },
    population: 16718971,
    fifa: 'CAM',
    car: { signs: ['K'], side: 'right' },
    timezones: ['UTC+07:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/kh.png',
      svg: 'https://flagcdn.com/kh.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/kh.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/kh.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [11.55, 104.92] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Laos',
      official: "Lao People's Democratic Republic",
      nativeName: {
        lao: { official: 'ສາທາລະນະ ຊາທິປະໄຕ ຄົນລາວ ຂອງ', common: 'ສປປລາວ' }
      }
    },
    tld: ['.la'],
    cca2: 'LA',
    ccn3: '418',
    cca3: 'LAO',
    cioc: 'LAO',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { LAK: { name: 'Lao kip', symbol: '₭' } },
    idd: { root: '+8', suffixes: ['56'] },
    capital: ['Vientiane'],
    altSpellings: [
      'LA',
      'Lao',
      "Lao People's Democratic Republic",
      'Sathalanalat Paxathipatai Paxaxon Lao'
    ],
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    languages: { lao: 'Lao' },
    translations: {
      ara: { official: 'جمهورية لاوس الديمقراطية الشعبية', common: 'لاوس' },
      bre: { official: 'Republik Demokratel ar Bobl Lao', common: 'Laos' },
      ces: { official: 'Laoská lidově demokratická republika', common: 'Laos' },
      cym: { official: "Lao People's Democratic Republic", common: 'Laos' },
      deu: { official: 'Demokratische Volksrepublik Laos', common: 'Laos' },
      est: { official: 'Laose Demokraatlik Rahvavabariik', common: 'Laos' },
      fin: {
        official: 'Laosin demokraattinen kansantasavalta',
        common: 'Laos'
      },
      fra: {
        official: 'République démocratique populaire lao',
        common: 'Laos'
      },
      hrv: { official: 'Narodna Demokratska Republika', common: 'Laos' },
      hun: {
        official: 'Laoszi Népi Demokratikus Köztársaság',
        common: 'Laosz'
      },
      ita: {
        official: 'Repubblica democratica popolare del Laos',
        common: 'Laos'
      },
      jpn: { official: 'ラオス人民民主共和国', common: 'ラオス人民民主共和国' },
      kor: { official: '라오 인민 민주 공화국', common: '라오스' },
      nld: { official: 'Lao Democratische Volksrepubliek', common: 'Laos' },
      per: { official: 'جمهوری دموکراتیک خلق لائوس', common: 'لائوس' },
      pol: {
        official: 'Laotańska Republika Ludowo-Demokratyczna',
        common: 'Laos'
      },
      por: { official: 'Laos, República Democrática', common: 'Laos' },
      rus: {
        official: 'Лаосская Народно-Демократическая Республика',
        common: 'Лаос'
      },
      slk: { official: 'Laoská ľudovodemokratická republika', common: 'Laos' },
      spa: { official: 'República Democrática Popular Lao', common: 'Laos' },
      swe: { official: 'Demokratiska folkrepubliken Laos', common: 'Laos' },
      tur: { official: 'Laos Demokratik Halk Cumhuriyeti', common: 'Laos' },
      urd: { official: 'عوامی جمہوری جمہوریہ لاؤ', common: 'لاؤس' },
      zho: { official: '老挝人民民主共和国', common: '老挝' }
    },
    latlng: [18.0, 105.0],
    landlocked: true,
    borders: ['MMR', 'KHM', 'CHN', 'THA', 'VNM'],
    area: 236800.0,
    demonyms: {
      eng: { f: 'Laotian', m: 'Laotian' },
      fra: { f: 'Laotienne', m: 'Laotien' }
    },
    flag: '\uD83C\uDDF1\uD83C\uDDE6',
    maps: {
      googleMaps: 'https://goo.gl/maps/F3asVB7sRKgSnwbE7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/49903'
    },
    population: 7275556,
    gini: { 2018: 38.8 },
    fifa: 'LAO',
    car: { signs: ['LAO'], side: 'right' },
    timezones: ['UTC+07:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/la.png',
      svg: 'https://flagcdn.com/la.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/la.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/la.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [17.97, 102.6] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Taiwan',
      official: 'Republic of China (Taiwan)',
      nativeName: { zho: { official: '中華民國', common: '台灣' } }
    },
    tld: ['.tw', '.台灣', '.台湾'],
    cca2: 'TW',
    ccn3: '158',
    cca3: 'TWN',
    cioc: 'TPE',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { TWD: { name: 'New Taiwan dollar', symbol: '$' } },
    idd: { root: '+8', suffixes: ['86'] },
    capital: ['Taipei'],
    altSpellings: [
      'TW',
      'Táiwān',
      'Republic of China',
      '中華民國',
      'Zhōnghuá Mínguó',
      'Chinese Taipei'
    ],
    region: 'Asia',
    subregion: 'Eastern Asia',
    languages: { zho: 'Chinese' },
    translations: {
      ara: { official: 'جمهورية الصين (تايوان)', common: 'تايوان' },
      bre: { official: 'Republik Sina (Taiwan)', common: 'Taiwan' },
      ces: { official: 'Čínská republika', common: 'Tchaj-wan' },
      cym: { official: 'Republic of China (Taiwan)', common: 'Taiwan' },
      deu: { official: 'Republik China (Taiwan)', common: 'Taiwan' },
      est: { official: 'Taiwani', common: 'Taiwan' },
      fin: { official: 'Kiinan tasavalta', common: 'Taiwan' },
      fra: { official: 'République de Chine (Taïwan)', common: 'Taïwan' },
      hrv: { official: 'Republika Kina', common: 'Tajvan' },
      hun: { official: 'Kínai Köztársaság', common: 'Tajvan' },
      ita: { official: 'Repubblica cinese (Taiwan)', common: 'Taiwan' },
      jpn: { official: '中華民国', common: '台湾' },
      kor: { official: '중화민국', common: '대만' },
      nld: { official: 'Republiek China (Taiwan)', common: 'Taiwan' },
      per: { official: 'جمهوری چین', common: 'تایوان' },
      pol: { official: 'Republika Chińska (Tajwan)', common: 'Tajwan' },
      por: { official: 'República da China', common: 'Ilha Formosa' },
      rus: { official: 'Китайская Республика', common: 'Тайвань' },
      slk: { official: 'Čínska republika', common: 'Taiwan' },
      spa: { official: 'República de China en Taiwán', common: 'Taiwán' },
      swe: { official: 'Republiken Kina', common: 'Taiwan' },
      tur: { official: 'Çin Cumhuriyeti (Tayvan)', common: 'Tayvan' },
      urd: { official: 'جمہوریہ چین (تائیوان)', common: 'تائیوان' }
    },
    latlng: [23.5, 121.0],
    landlocked: false,
    area: 36193.0,
    demonyms: {
      eng: { f: 'Taiwanese', m: 'Taiwanese' },
      fra: { f: 'Taïwanaise', m: 'Taïwanais' }
    },
    flag: '\uD83C\uDDF9\uD83C\uDDFC',
    maps: {
      googleMaps: 'https://goo.gl/maps/HgMKFQjNadF3Wa6B6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/449220'
    },
    population: 23503349,
    fifa: 'TPE',
    car: { signs: ['RC'], side: 'right' },
    timezones: ['UTC+08:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/tw.png',
      svg: 'https://flagcdn.com/tw.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/tw.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/tw.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [25.03, 121.52] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'India',
      official: 'Republic of India',
      nativeName: {
        eng: { official: 'Republic of India', common: 'India' },
        hin: { official: 'भारत गणराज्य', common: 'भारत' },
        tam: { official: 'இந்தியக் குடியரசு', common: 'இந்தியா' }
      }
    },
    tld: ['.in'],
    cca2: 'IN',
    ccn3: '356',
    cca3: 'IND',
    cioc: 'IND',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { INR: { name: 'Indian rupee', symbol: '₹' } },
    idd: { root: '+9', suffixes: ['1'] },
    capital: ['New Delhi'],
    altSpellings: [
      'IN',
      'Bhārat',
      'Republic of India',
      'Bharat Ganrajya',
      'இந்தியா'
    ],
    region: 'Asia',
    subregion: 'Southern Asia',
    languages: { eng: 'English', hin: 'Hindi', tam: 'Tamil' },
    translations: {
      ara: { official: 'جمهورية الهند', common: 'الهند' },
      bre: { official: 'Republik India', common: 'India' },
      ces: { official: 'Indická republika', common: 'Indie' },
      cym: { official: 'Republic of India', common: 'India' },
      deu: { official: 'Republik Indien', common: 'Indien' },
      est: { official: 'India Vabariik', common: 'India' },
      fin: { official: 'Intian tasavalta', common: 'Intia' },
      fra: { official: "République de l'Inde", common: 'Inde' },
      hrv: { official: 'Republika Indija', common: 'Indija' },
      hun: { official: 'Indiai Köztársaság', common: 'India' },
      ita: { official: "Repubblica dell'India", common: 'India' },
      jpn: { official: 'インド共和国', common: 'インド' },
      kor: { official: '인도 공화국', common: '인도' },
      nld: { official: 'Republiek India', common: 'India' },
      per: { official: 'جمهوری هندوستان', common: 'هند' },
      pol: { official: 'Republika Indii', common: 'Indie' },
      por: { official: 'República da Índia', common: 'Índia' },
      rus: { official: 'Республика Индия', common: 'Индия' },
      slk: { official: 'Indická republika', common: 'India' },
      spa: { official: 'República de la India', common: 'India' },
      swe: { official: 'Republiken Indien', common: 'Indien' },
      tur: { official: 'Hindistan Cumhuriyeti', common: 'Hindistan' },
      urd: { official: 'جمہوریہ بھارت', common: 'بھارت' },
      zho: { official: '印度共和国', common: '印度' }
    },
    latlng: [20.0, 77.0],
    landlocked: false,
    borders: ['BGD', 'BTN', 'MMR', 'CHN', 'NPL', 'PAK'],
    area: 3287590.0,
    demonyms: {
      eng: { f: 'Indian', m: 'Indian' },
      fra: { f: 'Indienne', m: 'Indien' }
    },
    flag: '\uD83C\uDDEE\uD83C\uDDF3',
    maps: {
      googleMaps: 'https://goo.gl/maps/WSk3fLwG4vtPQetp7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/304716'
    },
    population: 1380004385,
    gini: { 2011: 35.7 },
    fifa: 'IND',
    car: { signs: ['IND'], side: 'left' },
    timezones: ['UTC+05:30'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/in.png',
      svg: 'https://flagcdn.com/in.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/in.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/in.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [28.6, 77.2] },
    postalCode: { format: '######', regex: '^(\\d{6})$' }
  },
  {
    name: {
      common: 'Turkey',
      official: 'Republic of Turkey',
      nativeName: {
        tur: { official: 'Türkiye Cumhuriyeti', common: 'Türkiye' }
      }
    },
    tld: ['.tr'],
    cca2: 'TR',
    ccn3: '792',
    cca3: 'TUR',
    cioc: 'TUR',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { TRY: { name: 'Turkish lira', symbol: '₺' } },
    idd: { root: '+9', suffixes: ['0'] },
    capital: ['Ankara'],
    altSpellings: [
      'TR',
      'Turkiye',
      'Republic of Turkey',
      'Türkiye Cumhuriyeti'
    ],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { tur: 'Turkish' },
    translations: {
      ara: { official: 'الجمهورية التركية', common: 'تركيا' },
      bre: { official: 'Republik Turkia', common: 'Turkia' },
      ces: { official: 'Turecká republika', common: 'Turecko' },
      cym: { official: 'Republic of Turkey', common: 'Turkey' },
      deu: { official: 'Republik Türkei', common: 'Türkei' },
      est: { official: 'Türgi Vabariik', common: 'Türgi' },
      fin: { official: 'Turkin tasavalta', common: 'Turkki' },
      fra: { official: 'République de Turquie', common: 'Turquie' },
      hrv: { official: 'Republika Turska', common: 'Turska' },
      hun: { official: 'Török Köztársaság', common: 'Törökország' },
      ita: { official: 'Repubblica di Turchia', common: 'Turchia' },
      jpn: { official: 'トルコ共和国', common: 'トルコ' },
      kor: { official: '터키 공화국', common: '터키' },
      nld: { official: 'Republiek Turkije', common: 'Turkije' },
      per: { official: 'جمهوری ترکیه', common: 'ترکیه' },
      pol: { official: 'Republika Turcji', common: 'Turcja' },
      por: { official: 'República da Turquia', common: 'Turquia' },
      rus: { official: 'Республика Турции', common: 'Турция' },
      slk: { official: 'Turecká republika', common: 'Turecko' },
      spa: { official: 'República de Turquía', common: 'Turquía' },
      swe: { official: 'Republiken Turkiet', common: 'Turkiet' },
      tur: { official: 'Türkiye Cumhuriyeti', common: 'Türkiye' },
      urd: { official: 'جمہوریہ ترکی', common: 'ترکی' },
      zho: { official: '土耳其共和国', common: '土耳其' }
    },
    latlng: [39.0, 35.0],
    landlocked: false,
    borders: ['ARM', 'AZE', 'BGR', 'GEO', 'GRC', 'IRN', 'IRQ', 'SYR'],
    area: 783562.0,
    demonyms: {
      eng: { f: 'Turkish', m: 'Turkish' },
      fra: { f: 'Turque', m: 'Turc' }
    },
    flag: '\uD83C\uDDF9\uD83C\uDDF7',
    maps: {
      googleMaps: 'https://goo.gl/maps/dXFFraiUDfcB6Quk6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/174737'
    },
    population: 84339067,
    gini: { 2019: 41.9 },
    fifa: 'TUR',
    car: { signs: ['TR'], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/tr.png',
      svg: 'https://flagcdn.com/tr.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/tr.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/tr.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [39.93, 32.87] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Sri Lanka',
      official: 'Democratic Socialist Republic of Sri Lanka',
      nativeName: {
        sin: {
          official: 'ශ්‍රී ලංකා ප්‍රජාතාන්ත්‍රික සමාජවාදී ජනරජය',
          common: 'ශ්‍රී ලංකාව'
        },
        tam: { official: 'இலங்கை சனநாயக சோசலிசக் குடியரசு', common: 'இலங்கை' }
      }
    },
    tld: ['.lk', '.இலங்கை', '.ලංකා'],
    cca2: 'LK',
    ccn3: '144',
    cca3: 'LKA',
    cioc: 'SRI',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { LKR: { name: 'Sri Lankan rupee', symbol: 'Rs  රු' } },
    idd: { root: '+9', suffixes: ['4'] },
    capital: ['Sri Jayawardenepura Kotte'],
    altSpellings: [
      'LK',
      'ilaṅkai',
      'Democratic Socialist Republic of Sri Lanka'
    ],
    region: 'Asia',
    subregion: 'Southern Asia',
    languages: { sin: 'Sinhala', tam: 'Tamil' },
    translations: {
      ara: {
        official: 'جمهورية سريلانكا الديمقراطية الشعبية',
        common: 'سريلانكا'
      },
      bre: {
        official: 'Republik Demokratel ha Sokialour Sri Lanka',
        common: 'Sri Lanka'
      },
      ces: {
        official: 'Srílanská demokratická socialistická republika',
        common: 'Srí Lanka'
      },
      cym: {
        official: 'Democratic Socialist Republic of Sri Lanka',
        common: 'Sri Lanka'
      },
      deu: {
        official: 'Demokratische Sozialistische Republik Sri Lanka',
        common: 'Sri Lanka'
      },
      est: {
        official: 'Sri Lanka Demokraatlik Sotsialistlik Vabariik',
        common: 'Sri Lanka'
      },
      fin: {
        official: 'Sri Lankan demokraattinen sosialistinen tasavalta',
        common: 'Sri Lanka'
      },
      fra: {
        official: 'République démocratique socialiste du Sri Lanka',
        common: 'Sri Lanka'
      },
      hrv: {
        official: 'Demokratska Socijalističke Republike Šri Lanke',
        common: 'Šri Lanka'
      },
      hun: {
        official: 'Srí Lanka-i Demokratikus Szocialista Köztársaság',
        common: 'Srí Lanka'
      },
      ita: {
        official: 'Repubblica democratica socialista dello Sri Lanka',
        common: 'Sri Lanka'
      },
      jpn: { official: 'スリランカ民主社会主義共和国', common: 'スリランカ' },
      kor: { official: '스리랑카 민주 사회주의 공화국', common: '스리랑카' },
      nld: {
        official: 'Democratische Socialistische Republiek Sri Lanka',
        common: 'Sri Lanka'
      },
      per: {
        official: 'جمهوری دموکراتیک سوسیالیستی سری‌لانکا',
        common: 'سری‌لانکا'
      },
      pol: {
        official: 'Demokratyczno-Socjalistyczna Republika Sri Lanki',
        common: 'Sri Lanka'
      },
      por: {
        official: 'República Democrática Socialista do Sri Lanka',
        common: 'Sri Lanka'
      },
      rus: {
        official: 'Демократическая Социалистическая Республика Шри-Ланка',
        common: 'Шри-Ланка'
      },
      slk: {
        official: 'Srílanská demokratická socialistická republika',
        common: 'Srí Lanka'
      },
      spa: {
        official: 'República Democrática Socialista de Sri Lanka',
        common: 'Sri Lanka'
      },
      swe: {
        official: 'Demokratiska socialistiska republiken Sri Lanka',
        common: 'Sri Lanka'
      },
      tur: {
        official: 'Sri Lanka Demokratik Sosyalist Cumhuriyeti',
        common: 'Sri Lanka'
      },
      urd: {
        official: 'جمہوری و اشتراکی جمہوریہ سری لنکا',
        common: 'سری لنکا'
      },
      zho: { official: '斯里兰卡民主社会主义共和国', common: '斯里兰卡' }
    },
    latlng: [7.0, 81.0],
    landlocked: false,
    borders: ['IND'],
    area: 65610.0,
    demonyms: {
      eng: { f: 'Sri Lankan', m: 'Sri Lankan' },
      fra: { f: 'Sri-lankaise', m: 'Sri-lankais' }
    },
    flag: '\uD83C\uDDF1\uD83C\uDDF0',
    maps: {
      googleMaps: 'https://goo.gl/maps/VkPHoeFSfgzRQCDv8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/536807'
    },
    population: 21919000,
    gini: { 2016: 39.3 },
    fifa: 'SRI',
    car: { signs: ['CL'], side: 'left' },
    timezones: ['UTC+05:30'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/lk.png',
      svg: 'https://flagcdn.com/lk.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/lk.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/lk.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [6.89, 79.9] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Hong Kong',
      official:
        "Hong Kong Special Administrative Region of the People's Republic of China",
      nativeName: {
        eng: {
          official:
            "Hong Kong Special Administrative Region of the People's Republic of China",
          common: 'Hong Kong'
        },
        zho: { official: '中华人民共和国香港特别行政区', common: '香港' }
      }
    },
    tld: ['.hk', '.香港'],
    cca2: 'HK',
    ccn3: '344',
    cca3: 'HKG',
    cioc: 'HKG',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { HKD: { name: 'Hong Kong dollar', symbol: '$' } },
    idd: { root: '+8', suffixes: ['52'] },
    capital: ['City of Victoria'],
    altSpellings: ['HK'],
    region: 'Asia',
    subregion: 'Eastern Asia',
    languages: { eng: 'English', zho: 'Chinese' },
    translations: {
      ara: {
        official: 'منطقة هونغ كونغ الادارية التابعة لجمهورية الصين الشعبية',
        common: 'هونغ كونغ'
      },
      bre: {
        official:
          'Rannvro velestradurel arbennik Hong Kong eus Republik pobl Sina',
        common: 'Hong Kong'
      },
      ces: {
        official:
          'Zvláštní administrativní oblast Čínské lidové republiky Hongkong',
        common: 'Hongkong'
      },
      cym: {
        official:
          "Hong Kong Special Administrative Region of the People's Republic of China",
        common: 'Hong Kong'
      },
      deu: {
        official: 'Sonderverwaltungszone Hongkong der Volksrepublik China',
        common: 'Hongkong'
      },
      est: { official: 'Hongkongi erihalduspiirkond', common: 'Hongkong' },
      fin: { official: 'Hong Kongin erityishallintoalue', common: 'Hongkong' },
      fra: {
        official:
          'Région administrative spéciale de Hong Kong de la République populaire de Chine',
        common: 'Hong Kong'
      },
      hrv: {
        official: 'Hong Kong Posebnog upravnog područjaNarodne Republike Kine',
        common: 'Hong Kong'
      },
      hun: { official: 'Hongkong', common: 'Hongkong' },
      ita: {
        official:
          'Hong Kong Regione amministrativa speciale della Repubblica Popolare Cinese',
        common: 'Hong Kong'
      },
      jpn: { official: '中華人民共和国香港特別行政区', common: '香港' },
      kor: { official: '중화인민공화국 홍콩 특별행정구', common: '홍콩' },
      nld: {
        official:
          'Hong Kong Speciale Administratieve Regio van de Volksrepubliek China',
        common: 'Hongkong'
      },
      per: { official: 'هُنگ کُنگ', common: 'هُنگ کُنگ' },
      pol: {
        official:
          'Specjalny Region Administracyjny Chińskiej Republiki Ludowej Hongkong',
        common: 'Hongkong'
      },
      por: {
        official:
          'Hong Kong Região Administrativa Especial da República Popular da China',
        common: 'Hong Kong'
      },
      rus: {
        official:
          'Hong Kong Специальный административный район Китайской Народной Республики Китая',
        common: 'Гонконг'
      },
      slk: {
        official:
          'Špeciálna administratívna oblasťČínskej ľudovej republiky Hongkong',
        common: 'Hongkong'
      },
      spa: {
        official:
          'Hong Kong Región Administrativa Especial de la República Popular China',
        common: 'Hong Kong'
      },
      swe: { official: 'Hongkong', common: 'Hongkong' },
      tur: {
        official: 'Çin Halk Cumhuriyeti Hong Kong Özel İdari Bölgesi',
        common: 'Hong Kong'
      },
      urd: {
        official: 'ہانگ کانگ عوامی جمہوریہ چین کا خصوصی انتظامی علاقہ',
        common: 'ہانگ کانگ'
      }
    },
    latlng: [22.267, 114.188],
    landlocked: false,
    borders: ['CHN'],
    area: 1104.0,
    demonyms: {
      eng: { f: 'Hong Konger', m: 'Hong Konger' },
      fra: { f: 'Hongkongaise', m: 'Hongkongais' }
    },
    flag: '\uD83C\uDDED\uD83C\uDDF0',
    maps: {
      googleMaps: 'https://goo.gl/maps/1sEnNmT47ffrC8MU8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/913110'
    },
    population: 7500700,
    fifa: 'HKG',
    car: { signs: ['HK'], side: 'left' },
    timezones: ['UTC+08:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/hk.png',
      svg: 'https://flagcdn.com/hk.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/hk.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/hk.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [48.41, -123.33] }
  },
  {
    name: {
      common: 'Thailand',
      official: 'Kingdom of Thailand',
      nativeName: { tha: { official: 'ราชอาณาจักรไทย', common: 'ประเทศไทย' } }
    },
    tld: ['.th', '.ไทย'],
    cca2: 'TH',
    ccn3: '764',
    cca3: 'THA',
    cioc: 'THA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { THB: { name: 'Thai baht', symbol: '฿' } },
    idd: { root: '+6', suffixes: ['6'] },
    capital: ['Bangkok'],
    altSpellings: [
      'TH',
      'Prathet',
      'Thai',
      'Kingdom of Thailand',
      'ราชอาณาจักรไทย',
      'Ratcha Anachak Thai'
    ],
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    languages: { tha: 'Thai' },
    translations: {
      ara: { official: 'مملكة تايلند', common: 'تايلند' },
      bre: { official: 'Rouantelezh Thailand', common: 'Thailand' },
      ces: { official: 'Thajské království', common: 'Thajsko' },
      cym: { official: 'Kingdom of Thailand', common: 'Thailand' },
      deu: { official: 'Königreich Thailand', common: 'Thailand' },
      est: { official: 'Tai Kuningriik', common: 'Tai' },
      fin: { official: 'Thaimaan kuningaskunta', common: 'Thaimaa' },
      fra: { official: 'Royaume de Thaïlande', common: 'Thaïlande' },
      hrv: { official: 'Kraljevina Tajland', common: 'Tajland' },
      hun: { official: 'Thaiföldi Királyság', common: 'Thaiföld' },
      ita: { official: 'Regno di Thailandia', common: 'Tailandia' },
      jpn: { official: 'タイ王国', common: 'タイ' },
      kor: { official: '타이 왕국', common: '태국' },
      nld: { official: 'Koninkrijk Thailand', common: 'Thailand' },
      per: { official: 'پادشاهی تایلند', common: 'تایلند' },
      pol: { official: 'Królestwo Tajlandii', common: 'Tajlandia' },
      por: { official: 'Reino da Tailândia', common: 'Tailândia' },
      rus: { official: 'Королевство Таиланд', common: 'Таиланд' },
      slk: { official: 'Thajské kráľovstvo', common: 'Thajsko' },
      spa: { official: 'Reino de Tailandia', common: 'Tailandia' },
      swe: { official: 'Konungariket Thailand', common: 'Thailand' },
      tur: { official: 'Tayland Krallığı', common: 'Tayland' },
      urd: { official: 'مملکتِ تھائی لینڈ', common: 'تھائی لینڈ' },
      zho: { official: '泰王国', common: '泰国' }
    },
    latlng: [15.0, 100.0],
    landlocked: false,
    borders: ['MMR', 'KHM', 'LAO', 'MYS'],
    area: 513120.0,
    demonyms: {
      eng: { f: 'Thai', m: 'Thai' },
      fra: { f: 'Thaïlandaise', m: 'Thaïlandais' }
    },
    flag: '\uD83C\uDDF9\uD83C\uDDED',
    maps: {
      googleMaps: 'https://goo.gl/maps/qeU6uqsfW4nCCwzw9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/2067731'
    },
    population: 69799978,
    gini: { 2019: 34.9 },
    fifa: 'THA',
    car: { signs: ['T'], side: 'left' },
    timezones: ['UTC+07:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/th.png',
      svg: 'https://flagcdn.com/th.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/th.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/th.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [13.75, 100.52] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Philippines',
      official: 'Republic of the Philippines',
      nativeName: {
        eng: { official: 'Republic of the Philippines', common: 'Philippines' },
        fil: { official: 'Republic of the Philippines', common: 'Pilipinas' }
      }
    },
    tld: ['.ph'],
    cca2: 'PH',
    ccn3: '608',
    cca3: 'PHL',
    cioc: 'PHI',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { PHP: { name: 'Philippine peso', symbol: '₱' } },
    idd: { root: '+6', suffixes: ['3'] },
    capital: ['Manila'],
    altSpellings: [
      'PH',
      'Republic of the Philippines',
      'Repúblika ng Pilipinas'
    ],
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    languages: { eng: 'English', fil: 'Filipino' },
    translations: {
      ara: { official: 'جمهورية الفلبين', common: 'الفلبين' },
      bre: { official: 'Republik Filipinez', common: 'Filipinez' },
      ces: { official: 'Filipínská republika', common: 'Filipíny' },
      cym: { official: 'Republic of the Philippines', common: 'Philippines' },
      deu: { official: 'Republik der Philippinen', common: 'Philippinen' },
      est: { official: 'Filipiini Vabariik', common: 'Filipiinid' },
      fin: { official: 'Filippiinien tasavalta', common: 'Filippiinit' },
      fra: { official: 'République des Philippines', common: 'Philippines' },
      hrv: { official: 'Republika Filipini', common: 'Filipini' },
      hun: {
        official: 'Fülöp-szigeteki Köztársaság',
        common: 'Fülöp-szigetek'
      },
      ita: { official: 'Repubblica delle Filippine', common: 'Filippine' },
      jpn: { official: 'フィリピン共和国', common: 'フィリピン' },
      kor: { official: '필리핀 공화국', common: '필리핀' },
      nld: { official: 'Republiek der Filipijnen', common: 'Filipijnen' },
      per: { official: 'جمهوری فیلیپین', common: 'فیلیپین' },
      pol: { official: 'Republika Filipin', common: 'Filipiny' },
      por: { official: 'República das Filipinas', common: 'Filipinas' },
      rus: { official: 'Республика Филиппины', common: 'Филиппины' },
      slk: { official: 'Filipínska republika', common: 'Filipíny' },
      spa: { official: 'República de las Filipinas', common: 'Filipinas' },
      swe: { official: 'Republiken Filippinerna', common: 'Filippinerna' },
      tur: { official: 'Filipinler Cumhuriyeti', common: 'Filipinler' },
      urd: { official: 'جمہوریہ فلپائن', common: 'فلپائن' },
      zho: { official: '菲律宾共和国', common: '菲律宾' }
    },
    latlng: [13.0, 122.0],
    landlocked: false,
    area: 342353.0,
    demonyms: {
      eng: { f: 'Filipino', m: 'Filipino' },
      fra: { f: 'Philippine', m: 'Philippin' }
    },
    flag: '\uD83C\uDDF5\uD83C\uDDED',
    maps: {
      googleMaps: 'https://goo.gl/maps/k8T2fb5VMUfsWFX6A',
      openStreetMaps: 'https://www.openstreetmap.org/relation/443174'
    },
    population: 109581085,
    gini: { 2018: 42.3 },
    fifa: 'PHI',
    car: { signs: ['RP'], side: 'right' },
    timezones: ['UTC+08:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/ph.png',
      svg: 'https://flagcdn.com/ph.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ph.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ph.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [14.6, 120.97] },
    postalCode: { format: '####', regex: '^(\\d{4})$' }
  },
  {
    name: {
      common: 'Yemen',
      official: 'Republic of Yemen',
      nativeName: { ara: { official: 'الجمهورية اليمنية', common: 'اليَمَن' } }
    },
    tld: ['.ye'],
    cca2: 'YE',
    ccn3: '887',
    cca3: 'YEM',
    cioc: 'YEM',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { YER: { name: 'Yemeni rial', symbol: '﷼' } },
    idd: { root: '+9', suffixes: ['67'] },
    capital: ["Sana'a"],
    altSpellings: ['YE', 'Yemeni Republic', 'al-Jumhūriyyah al-Yamaniyyah'],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { ara: 'Arabic' },
    translations: {
      ara: { official: 'الجمهورية اليمنية', common: 'اليمن' },
      bre: { official: 'Republik Yemen', common: 'Yemen' },
      ces: { official: 'Jemenská republika', common: 'Jemen' },
      cym: { official: 'Republic of Yemen', common: 'Yemen' },
      deu: { official: 'Republik Jemen', common: 'Jemen' },
      est: { official: 'Jeemeni Vabariik', common: 'Jeemen' },
      fin: { official: 'Jemenin tasavalta', common: 'Jemen' },
      fra: { official: 'République du Yémen', common: 'Yémen' },
      hrv: { official: 'Republika Jemen', common: 'Jemen' },
      hun: { official: 'Jemeni Köztársaság', common: 'Jemen' },
      ita: { official: 'Repubblica dello Yemen', common: 'Yemen' },
      jpn: { official: 'イエメン共和国', common: 'イエメン' },
      kor: { official: '예멘 공화국', common: '예멘' },
      nld: { official: 'Republiek Jemen', common: 'Jemen' },
      per: { official: 'جمهوری یمن', common: 'یمن' },
      pol: { official: 'Republika Jemeńska', common: 'Jemen' },
      por: { official: 'República do Iêmen', common: 'Iémen' },
      rus: { official: 'Йеменская Республика', common: 'Йемен' },
      slk: { official: 'Jemenská republika', common: 'Jemen' },
      spa: { official: 'República de Yemen', common: 'Yemen' },
      swe: { official: 'Republiken Jemen', common: 'Jemen' },
      tur: { official: 'Yemen Cumhuriyeti', common: 'Yemen' },
      urd: { official: 'جمہوریہ یمن', common: 'یمن' },
      zho: { official: '也门共和国', common: '也门' }
    },
    latlng: [15.0, 48.0],
    landlocked: false,
    borders: ['OMN', 'SAU'],
    area: 527968.0,
    demonyms: {
      eng: { f: 'Yemeni', m: 'Yemeni' },
      fra: { f: 'Yéménite', m: 'Yéménite' }
    },
    flag: '\uD83C\uDDFE\uD83C\uDDEA',
    maps: {
      googleMaps: 'https://goo.gl/maps/WCmE76HKcLideQQw7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/305092'
    },
    population: 29825968,
    gini: { 2014: 36.7 },
    fifa: 'YEM',
    car: { signs: ['YAR'], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/ye.png',
      svg: 'https://flagcdn.com/ye.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ye.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ye.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [15.37, 44.19] }
  },
  {
    name: {
      common: 'South Korea',
      official: 'Republic of Korea',
      nativeName: { kor: { official: '대한민국', common: '한국' } }
    },
    tld: ['.kr', '.한국'],
    cca2: 'KR',
    ccn3: '410',
    cca3: 'KOR',
    cioc: 'KOR',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { KRW: { name: 'South Korean won', symbol: '₩' } },
    idd: { root: '+8', suffixes: ['2'] },
    capital: ['Seoul'],
    altSpellings: [
      'KR',
      'Korea, Republic of',
      'Republic of Korea',
      '남한',
      '남조선'
    ],
    region: 'Asia',
    subregion: 'Eastern Asia',
    languages: { kor: 'Korean' },
    translations: {
      ara: { official: 'جمهورية كوريا', common: 'كوريا الجنوبية' },
      bre: { official: 'Republik Korea', common: 'Korea ar Su' },
      ces: { official: 'Korejská republika', common: 'Jižní Korea' },
      cym: { official: 'Republic of Korea', common: 'South Korea' },
      deu: { official: 'Republik Korea', common: 'Südkorea' },
      est: { official: 'Korea Vabariik', common: 'Lõuna-Korea' },
      fin: { official: 'Korean tasavalta', common: 'Etelä-Korea' },
      fra: { official: 'République de Corée', common: 'Corée du Sud' },
      hrv: { official: 'Republika Koreja', common: 'Južna Koreja' },
      hun: { official: 'Koreai Köztársaság', common: 'Dél-Korea' },
      ita: { official: 'Repubblica di Corea', common: 'Corea del Sud' },
      jpn: { official: '大韓民国', common: '韓国' },
      kor: { official: '대한민국', common: '한국' },
      nld: { official: 'Republiek Korea', common: 'Zuid-Korea' },
      per: { official: 'جمهوری کره', common: 'کرهٔ جنوبی' },
      pol: { official: 'Republika Korei', common: 'Korea Południowa' },
      por: { official: 'República da Coreia', common: 'Coreia do Sul' },
      rus: { official: 'Республика Корея', common: 'Южная Корея' },
      slk: { official: 'Kórejská republika', common: 'Južná Kórea' },
      spa: { official: 'República de Corea', common: 'Corea del Sur' },
      swe: { official: 'Republiken Korea', common: 'Sydkorea' },
      tur: { official: 'Kore Cumhuriyeti', common: 'Güney Kore' },
      urd: { official: 'جمہوریہ کوریا ', common: 'جنوبی کوریا' },
      zho: { official: '大韩民国', common: '韩国' }
    },
    latlng: [37.0, 127.5],
    landlocked: false,
    borders: ['PRK'],
    area: 100210.0,
    demonyms: {
      eng: { f: 'South Korean', m: 'South Korean' },
      fra: { f: 'Sud-coréenne', m: 'Sud-coréen' }
    },
    flag: '\uD83C\uDDF0\uD83C\uDDF7',
    maps: {
      googleMaps: 'https://goo.gl/maps/7ecjaJXefjAQhxjGA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/307756'
    },
    population: 51780579,
    gini: { 2016: 31.4 },
    fifa: 'KOR',
    car: { signs: ['ROK'], side: 'right' },
    timezones: ['UTC+09:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/kr.png',
      svg: 'https://flagcdn.com/kr.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/kr.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/kr.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [37.55, 126.98] },
    postalCode: { format: 'SEOUL ###-###', regex: '^(?:SEOUL)*(\\d{6})$' }
  },
  {
    name: {
      common: 'Israel',
      official: 'State of Israel',
      nativeName: {
        ara: { official: 'دولة إسرائيل', common: 'إسرائيل' },
        heb: { official: 'מדינת ישראל', common: 'ישראל' }
      }
    },
    tld: ['.il'],
    cca2: 'IL',
    ccn3: '376',
    cca3: 'ISR',
    cioc: 'ISR',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { ILS: { name: 'Israeli new shekel', symbol: '₪' } },
    idd: { root: '+9', suffixes: ['72'] },
    capital: ['Jerusalem'],
    altSpellings: ['IL', 'State of Israel', "Medīnat Yisrā'el"],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { ara: 'Arabic', heb: 'Hebrew' },
    translations: {
      ara: { official: 'دولة إسرائيل', common: 'إسرائيل' },
      bre: { official: 'Stad Israel', common: 'Israel' },
      ces: { official: 'Stát Izrael', common: 'Izrael' },
      cym: { official: 'State of Israel', common: 'Israel' },
      deu: { official: 'Staat Israel', common: 'Israel' },
      est: { official: 'Iisraeli Riik', common: 'Iisrael' },
      fin: { official: 'Israelin valtio', common: 'Israel' },
      fra: { official: "État d'Israël", common: 'Israël' },
      hrv: { official: 'Država Izrael', common: 'Izrael' },
      hun: { official: 'Izrael', common: 'Izrael' },
      ita: { official: 'Stato di Israele', common: 'Israele' },
      jpn: { official: 'イスラエル国', common: 'イスラエル' },
      kor: { official: '이스라엘국', common: '이스라엘' },
      nld: { official: 'Staat Israël', common: 'Israël' },
      per: { official: 'فلسطين اشغالی', common: 'فلسطين اشغالی' },
      pol: { official: 'Państwo Izrael', common: 'Izrael' },
      por: { official: 'Estado de Israel', common: 'Israel' },
      rus: { official: 'Государство Израиль', common: 'Израиль' },
      slk: { official: 'Izraelský štát', common: 'Izrael' },
      spa: { official: 'Estado de Israel', common: 'Israel' },
      swe: { official: 'Staten Israel', common: 'Israel' },
      tur: { official: 'İsrail Devleti', common: 'İsrail' },
      urd: { official: 'ریاستِ اسرائیل', common: 'اسرائیل' },
      zho: { official: '以色列国', common: '以色列' }
    },
    latlng: [31.47, 35.13],
    landlocked: false,
    borders: ['EGY', 'JOR', 'LBN', 'PSE', 'SYR'],
    area: 20770.0,
    demonyms: {
      eng: { f: 'Israeli', m: 'Israeli' },
      fra: { f: 'Israélienne', m: 'Israélien' }
    },
    flag: '\uD83C\uDDEE\uD83C\uDDF1',
    maps: {
      googleMaps: 'https://goo.gl/maps/6UY1AH8XeafVwdC97',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1473946'
    },
    population: 9216900,
    gini: { 2016: 39.0 },
    fifa: 'ISR',
    car: { signs: ['IL'], side: 'right' },
    timezones: ['UTC+02:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/il.png',
      svg: 'https://flagcdn.com/il.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/il.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/il.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [31.77, 35.23] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Maldives',
      official: 'Republic of the Maldives',
      nativeName: {
        div: {
          official: 'ދިވެހިރާއްޖޭގެ ޖުމްހޫރިއްޔާ',
          common: 'ދިވެހިރާއްޖޭގެ'
        }
      }
    },
    tld: ['.mv'],
    cca2: 'MV',
    ccn3: '462',
    cca3: 'MDV',
    cioc: 'MDV',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { MVR: { name: 'Maldivian rufiyaa', symbol: '.ރ' } },
    idd: { root: '+9', suffixes: ['60'] },
    capital: ['Malé'],
    altSpellings: [
      'MV',
      'Maldive Islands',
      'Republic of the Maldives',
      'Dhivehi Raajjeyge Jumhooriyya'
    ],
    region: 'Asia',
    subregion: 'Southern Asia',
    languages: { div: 'Maldivian' },
    translations: {
      ara: { official: 'جمهورية المالديف', common: 'المالديف' },
      bre: { official: 'Republik Maldivez', common: 'Maldivez' },
      ces: { official: 'Maledivská republika', common: 'Maledivy' },
      cym: { official: 'Republic of the Maldives', common: 'Maldives' },
      deu: { official: 'Republik Malediven', common: 'Malediven' },
      est: { official: 'Maldiivi Vabariik', common: 'Maldiivid' },
      fin: { official: 'Malediivien tasavalta', common: 'Malediivit' },
      fra: { official: 'République des Maldives', common: 'Maldives' },
      hrv: { official: 'Republika Maldivi', common: 'Maldivi' },
      hun: { official: 'Maldív-szigetek', common: 'Maldív-szigetek' },
      ita: { official: 'Repubblica delle Maldive', common: 'Maldive' },
      jpn: { official: 'モルディブ共和国', common: 'モルディブ' },
      kor: { official: '몰디브 공화국', common: '몰디브' },
      nld: { official: 'Republiek van de Malediven', common: 'Maldiven' },
      per: { official: 'جمهوری مالدیو', common: 'مالدیو' },
      pol: { official: 'Republika Malediwów', common: 'Malediwy' },
      por: { official: 'República das Maldivas', common: 'Maldivas' },
      rus: { official: 'Республика Мальдивы', common: 'Мальдивы' },
      slk: { official: 'Maldivská republika', common: 'Maldivy' },
      spa: { official: 'República de las Maldivas', common: 'Maldivas' },
      swe: { official: 'Republiken Maldiverna', common: 'Maldiverna' },
      tur: { official: 'Maldivler Cumhuriyeti', common: 'Maldivler' },
      urd: { official: 'جمہوریہ مالدیپ', common: 'مالدیپ' },
      zho: { official: '马尔代夫共和国', common: '马尔代夫' }
    },
    latlng: [3.25, 73.0],
    landlocked: false,
    area: 300.0,
    demonyms: {
      eng: { f: 'Maldivan', m: 'Maldivan' },
      fra: { f: 'Maldivienne', m: 'Maldivien' }
    },
    flag: '\uD83C\uDDF2\uD83C\uDDFB',
    maps: {
      googleMaps: 'https://goo.gl/maps/MNAWGq9vEdbZ9vUV7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/536773'
    },
    population: 540542,
    gini: { 2016: 31.3 },
    fifa: 'MDV',
    car: { signs: ['MV'], side: 'left' },
    timezones: ['UTC+05:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/mv.png',
      svg: 'https://flagcdn.com/mv.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/mv.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/mv.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [4.17, 73.51] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Kyrgyzstan',
      official: 'Kyrgyz Republic',
      nativeName: {
        kir: { official: 'Кыргыз Республикасы', common: 'Кыргызстан' },
        rus: { official: 'Кыргызская Республика', common: 'Киргизия' }
      }
    },
    tld: ['.kg'],
    cca2: 'KG',
    ccn3: '417',
    cca3: 'KGZ',
    cioc: 'KGZ',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { KGS: { name: 'Kyrgyzstani som', symbol: 'с' } },
    idd: { root: '+9', suffixes: ['96'] },
    capital: ['Bishkek'],
    altSpellings: [
      'KG',
      'Киргизия',
      'Kyrgyz Republic',
      'Кыргыз Республикасы',
      'Kyrgyz Respublikasy'
    ],
    region: 'Asia',
    subregion: 'Central Asia',
    languages: { kir: 'Kyrgyz', rus: 'Russian' },
    translations: {
      ara: { official: 'الجمهورية القيرغيزية', common: 'قيرغيزستان' },
      bre: { official: 'Republik Kirgiz', common: 'Kirgizstan' },
      ces: { official: 'Kyrgyzská republika', common: 'Kyrgyzstán' },
      cym: { official: 'Kyrgyz Republic', common: 'Kyrgyzstan' },
      deu: { official: 'Kirgisische Republik', common: 'Kirgisistan' },
      est: { official: 'Kirgiisi Vabariik', common: 'Kõrgõzstan' },
      fin: { official: 'Kirgisian tasavalta', common: 'Kirgisia' },
      fra: { official: 'République kirghize', common: 'Kirghizistan' },
      hrv: { official: 'Kirgistanu', common: 'Kirgistan' },
      hun: { official: 'Kirgiz Köztársaság', common: 'Kirgizisztán' },
      ita: { official: 'Kirghizistan', common: 'Kirghizistan' },
      jpn: { official: 'キルギス共和国', common: 'キルギス' },
      kor: { official: '키르기스 공화국', common: '키르기스스탄' },
      nld: { official: 'Kirgizische Republiek', common: 'Kirgizië' },
      per: { official: 'جمهوری قِرقیزستان', common: 'قرقیزستان' },
      pol: { official: 'Republika Kirgiska', common: 'Kirgistan' },
      por: { official: 'República do Quirguistão', common: 'Quirguistão' },
      rus: { official: 'Кыргызская Республика', common: 'Киргизия' },
      slk: { official: 'Kirgizská republika', common: 'Kirgizsko' },
      spa: { official: 'República Kirguisa', common: 'Kirguizistán' },
      swe: { official: 'Republiken Kirgizistan', common: 'Kirgizistan' },
      tur: { official: 'Kırgızistan Cumhuriyeti', common: 'Kırgızistan' },
      urd: { official: 'جمہوریہ کرغیزستان', common: 'کرغیزستان' },
      zho: { official: '吉尔吉斯斯坦共和国', common: '吉尔吉斯斯坦' }
    },
    latlng: [41.0, 75.0],
    landlocked: true,
    borders: ['CHN', 'KAZ', 'TJK', 'UZB'],
    area: 199951.0,
    demonyms: {
      eng: { f: 'Kirghiz', m: 'Kirghiz' },
      fra: { f: 'Kirghize', m: 'Kirghize' }
    },
    flag: '\uD83C\uDDF0\uD83C\uDDEC',
    maps: {
      googleMaps: 'https://goo.gl/maps/SKG8BSMMQVvxkRkB7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/178009'
    },
    population: 6591600,
    gini: { 2019: 29.7 },
    fifa: 'KGZ',
    car: { signs: ['KS'], side: 'right' },
    timezones: ['UTC+06:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/kg.png',
      svg: 'https://flagcdn.com/kg.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/kg.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/kg.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [42.87, 74.6] },
    postalCode: { format: '######', regex: '^(\\d{6})$' }
  },
  {
    name: {
      common: 'Iran',
      official: 'Islamic Republic of Iran',
      nativeName: { fas: { official: 'جمهوری اسلامی ایران', common: 'ایران' } }
    },
    tld: ['.ir', 'ایران.'],
    cca2: 'IR',
    ccn3: '364',
    cca3: 'IRN',
    cioc: 'IRI',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { IRR: { name: 'Iranian rial', symbol: '﷼' } },
    idd: { root: '+9', suffixes: ['8'] },
    capital: ['Tehran'],
    altSpellings: [
      'IR',
      'Islamic Republic of Iran',
      'Iran, Islamic Republic of',
      'Jomhuri-ye Eslāmi-ye Irān'
    ],
    region: 'Asia',
    subregion: 'Southern Asia',
    languages: { fas: 'Persian (Farsi)' },
    translations: {
      ara: { official: 'جمهورية إيران الإسلامية', common: 'إيران' },
      bre: { official: 'Republik Islamek Iran', common: 'Iran' },
      ces: { official: 'Islámská republika Írán', common: 'Írán' },
      cym: { official: 'Islamic Republic of Iran', common: 'Iran' },
      deu: { official: 'Islamische Republik Iran', common: 'Iran' },
      est: { official: 'Iraani Islamivabariik', common: 'Iraan' },
      fin: { official: 'Iranin islamilainen tasavalta', common: 'Iran' },
      fra: { official: "République islamique d'Iran", common: 'Iran' },
      hrv: { official: 'Islamska Republika Iran', common: 'Iran' },
      hun: { official: 'Iráni Iszlám Köztársaság', common: 'Irán' },
      ita: { official: "Repubblica islamica dell'Iran", common: 'Iran' },
      jpn: {
        official: 'イラン·イスラム共和国',
        common: 'イラン・イスラム共和国'
      },
      kor: { official: '이란 이슬람 공화국', common: '이란' },
      nld: { official: 'Islamitische Republiek Iran', common: 'Iran' },
      pol: { official: 'Islamska Republika Iranu', common: 'Iran' },
      por: { official: 'República Islâmica do Irã', common: 'Irão' },
      rus: { official: 'Исламская Республика Иран', common: 'Иран' },
      slk: { official: 'Iránska islamská republika', common: 'Irán' },
      spa: { official: 'República Islámica de Irán', common: 'Iran' },
      swe: { official: 'Islamiska republiken Iran', common: 'Iran' },
      tur: { official: 'İran İslam Cumhuriyeti', common: 'İran' },
      urd: { official: 'جمہوریہ ایران', common: 'ایران' },
      zho: { official: '伊朗伊斯兰共和国', common: '伊朗' }
    },
    latlng: [32.0, 53.0],
    landlocked: false,
    borders: ['AFG', 'ARM', 'AZE', 'IRQ', 'PAK', 'TUR', 'TKM'],
    area: 1648195.0,
    demonyms: {
      eng: { f: 'Iranian', m: 'Iranian' },
      fra: { f: 'Iranienne', m: 'Iranien' }
    },
    flag: '\uD83C\uDDEE\uD83C\uDDF7',
    maps: {
      googleMaps: 'https://goo.gl/maps/dMgEGuacBPGYQnjY7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/304938'
    },
    population: 83992953,
    gini: { 2018: 42.0 },
    fifa: 'IRN',
    car: { signs: ['IR'], side: 'right' },
    timezones: ['UTC+03:30'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/ir.png',
      svg: 'https://flagcdn.com/ir.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ir.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ir.svg'
    },
    startOfWeek: 'turday',
    capitalInfo: { latlng: [35.7, 51.42] },
    postalCode: { format: '##########', regex: '^(\\d{10})$' }
  },
  {
    name: {
      common: 'Mongolia',
      official: 'Mongolia',
      nativeName: { mon: { official: 'Монгол улс', common: 'Монгол улс' } }
    },
    tld: ['.mn'],
    cca2: 'MN',
    ccn3: '496',
    cca3: 'MNG',
    cioc: 'MGL',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { MNT: { name: 'Mongolian tögrög', symbol: '₮' } },
    idd: { root: '+9', suffixes: ['76'] },
    capital: ['Ulan Bator'],
    altSpellings: ['MN'],
    region: 'Asia',
    subregion: 'Eastern Asia',
    languages: { mon: 'Mongolian' },
    translations: {
      ara: { official: 'جمهورية منغوليا', common: 'منغوليا' },
      bre: { official: 'Mongolia', common: 'Mongolia' },
      ces: { official: 'Stát Mongolsko', common: 'Mongolsko' },
      cym: { official: 'Mongolia', common: 'Mongolia' },
      deu: { official: 'Mongolei', common: 'Mongolei' },
      est: { official: 'Mongoolia', common: 'Mongoolia' },
      fin: { official: 'Mongolian tasavalta', common: 'Mongolia' },
      fra: { official: 'Mongolie', common: 'Mongolie' },
      hrv: { official: 'Mongolija', common: 'Mongolija' },
      hun: { official: 'Mongólia', common: 'Mongólia' },
      ita: { official: 'Mongolia', common: 'Mongolia' },
      jpn: { official: 'モンゴル', common: 'モンゴル' },
      kor: { official: '몽골', common: '몽골국' },
      nld: { official: 'Mongolië', common: 'Mongolië' },
      per: { official: 'مغولستان', common: 'مغولستان' },
      pol: { official: 'Mongolia', common: 'Mongolia' },
      por: { official: 'Mongólia', common: 'Mongólia' },
      rus: { official: 'Монголия', common: 'Монголия' },
      slk: { official: 'Mongolsko', common: 'Mongolsko' },
      spa: { official: 'Mongolia', common: 'Mongolia' },
      swe: { official: 'Mongoliet', common: 'Mongoliet' },
      tur: { official: 'Moğolistan', common: 'Moğolistan' },
      urd: { official: 'منگولیا', common: 'منگولیا' },
      zho: { official: '蒙古', common: '蒙古' }
    },
    latlng: [46.0, 105.0],
    landlocked: true,
    borders: ['CHN', 'RUS'],
    area: 1564110.0,
    demonyms: {
      eng: { f: 'Mongolian', m: 'Mongolian' },
      fra: { f: 'Mongole', m: 'Mongol' }
    },
    flag: '\uD83C\uDDF2\uD83C\uDDF3',
    maps: {
      googleMaps: 'https://goo.gl/maps/A1X7bMCKThBDNjzH6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/161033'
    },
    population: 3278292,
    gini: { 2018: 32.7 },
    fifa: 'MNG',
    car: { signs: ['MGL'], side: 'right' },
    timezones: ['UTC+07:00', 'UTC+08:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/mn.png',
      svg: 'https://flagcdn.com/mn.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/mn.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/mn.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [47.92, 106.91] },
    postalCode: { format: '######', regex: '^(\\d{6})$' }
  },
  {
    name: {
      common: 'Malaysia',
      official: 'Malaysia',
      nativeName: {
        eng: { official: 'Malaysia', common: 'Malaysia' },
        msa: { official: 'مليسيا', common: 'مليسيا' }
      }
    },
    tld: ['.my'],
    cca2: 'MY',
    ccn3: '458',
    cca3: 'MYS',
    cioc: 'MAS',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { MYR: { name: 'Malaysian ringgit', symbol: 'RM' } },
    idd: { root: '+6', suffixes: ['0'] },
    capital: ['Kuala Lumpur'],
    altSpellings: ['MY'],
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    languages: { eng: 'English', msa: 'Malay' },
    translations: {
      ara: { official: 'ماليزيا', common: 'ماليزيا' },
      bre: { official: 'Malaysia', common: 'Malaysia' },
      ces: { official: 'Malajsie', common: 'Malajsie' },
      cym: { official: 'Malaysia', common: 'Malaysia' },
      deu: { official: 'Malaysia', common: 'Malaysia' },
      est: { official: 'Malaisia', common: 'Malaisia' },
      fin: { official: 'Malesia', common: 'Malesia' },
      fra: { official: 'Fédération de Malaisie', common: 'Malaisie' },
      hrv: { official: 'Malezija', common: 'Malezija' },
      hun: { official: 'Malajzia', common: 'Malajzia' },
      ita: { official: 'Malaysia', common: 'Malesia' },
      jpn: { official: 'マレーシア', common: 'マレーシア' },
      kor: { official: '말레이시아', common: '말레이시아' },
      nld: { official: 'Maleisië', common: 'Maleisië' },
      per: { official: 'فدراسیون مالزی', common: 'مالزی' },
      pol: { official: 'Malezja', common: 'Malezja' },
      por: { official: 'Malásia', common: 'Malásia' },
      rus: { official: 'Малайзия', common: 'Малайзия' },
      slk: { official: 'Malajzia', common: 'Malajzia' },
      spa: { official: 'Malasia', common: 'Malasia' },
      swe: { official: 'Malaysia', common: 'Malaysia' },
      tur: { official: 'Malezya', common: 'Malezya' },
      urd: { official: 'ملائیشیا', common: 'ملائیشیا' },
      zho: { official: '马来西亚', common: '马来西亚' }
    },
    latlng: [2.5, 112.5],
    landlocked: false,
    borders: ['BRN', 'IDN', 'THA'],
    area: 330803.0,
    demonyms: {
      eng: { f: 'Malaysian', m: 'Malaysian' },
      fra: { f: 'Malaisienne', m: 'Malaisien' }
    },
    flag: '\uD83C\uDDF2\uD83C\uDDFE',
    maps: {
      googleMaps: 'https://goo.gl/maps/qrY1PNeUXGyXDcPy6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/2108121'
    },
    population: 32365998,
    gini: { 2015: 41.1 },
    fifa: 'MAS',
    car: { signs: ['MAL'], side: 'left' },
    timezones: ['UTC+08:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/my.png',
      svg: 'https://flagcdn.com/my.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/my.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/my.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [3.17, 101.7] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Uzbekistan',
      official: 'Republic of Uzbekistan',
      nativeName: {
        rus: { official: 'Республика Узбекистан', common: 'Узбекистан' },
        uzb: { official: "O'zbekiston Respublikasi", common: 'O‘zbekiston' }
      }
    },
    tld: ['.uz'],
    cca2: 'UZ',
    ccn3: '860',
    cca3: 'UZB',
    cioc: 'UZB',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { UZS: { name: 'Uzbekistani soʻm', symbol: "so'm" } },
    idd: { root: '+9', suffixes: ['98'] },
    capital: ['Tashkent'],
    altSpellings: [
      'UZ',
      'Republic of Uzbekistan',
      'O‘zbekiston Respublikasi',
      'Ўзбекистон Республикаси'
    ],
    region: 'Asia',
    subregion: 'Central Asia',
    languages: { rus: 'Russian', uzb: 'Uzbek' },
    translations: {
      ara: { official: 'جمهورية أوزباكستان', common: 'أوزباكستان' },
      bre: { official: 'Republik Ouzbekistan', common: 'Ouzbekistan' },
      ces: { official: 'Republika Uzbekistán', common: 'Uzbekistán' },
      cym: { official: 'Republic of Uzbekistan', common: 'Uzbekistan' },
      deu: { official: 'Republik Usbekistan', common: 'Usbekistan' },
      est: { official: 'Usbekistani Vabariik', common: 'Usbekistan' },
      fin: { official: 'Uzbekistanin tasavalta', common: 'Uzbekistan' },
      fra: { official: "République d'Ouzbékistan", common: 'Ouzbékistan' },
      hrv: { official: 'Republika Uzbekistan', common: 'Uzbekistan' },
      hun: { official: 'Üzbég Köztársaság', common: 'Üzbegisztán' },
      ita: { official: 'Repubblica di Uzbekistan', common: 'Uzbekistan' },
      jpn: { official: 'ウズベキスタン共和国', common: 'ウズベキスタン' },
      kor: { official: '우즈베키스탄 공화국', common: '우즈베키스탄' },
      nld: { official: 'Republiek Oezbekistan', common: 'Oezbekistan' },
      per: { official: 'جمهوری ازبکستان', common: 'ازبکستان' },
      pol: { official: 'Republika Uzbekistanu', common: 'Uzbekistan' },
      por: { official: 'República do Usbequistão', common: 'Uzbequistão' },
      rus: { official: 'Республика Узбекистан', common: 'Узбекистан' },
      slk: { official: 'Uzbecká republika', common: 'Uzbekistan' },
      spa: { official: 'República de Uzbekistán', common: 'Uzbekistán' },
      swe: { official: 'Republiken Uzbekistan', common: 'Uzbekistan' },
      tur: { official: 'Özbekistan Cumhuriyeti', common: 'Özbekistan' },
      urd: { official: 'جمہوریہ ازبکستان', common: 'ازبکستان' },
      zho: { official: '乌兹别克斯坦共和国', common: '乌兹别克斯坦' }
    },
    latlng: [41.0, 64.0],
    landlocked: true,
    borders: ['AFG', 'KAZ', 'KGZ', 'TJK', 'TKM'],
    area: 447400.0,
    demonyms: {
      eng: { f: 'Uzbekistani', m: 'Uzbekistani' },
      fra: { f: 'Ouzbèke', m: 'Ouzbèke' }
    },
    flag: '\uD83C\uDDFA\uD83C\uDDFF',
    maps: {
      googleMaps: 'https://goo.gl/maps/AJpo6MjMx23qSWCz8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/196240'
    },
    population: 34232050,
    gini: { 2003: 35.3 },
    fifa: 'UZB',
    car: { signs: ['UZ'], side: 'right' },
    timezones: ['UTC+05:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/uz.png',
      svg: 'https://flagcdn.com/uz.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/uz.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/uz.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [41.32, 69.25] },
    postalCode: { format: '######', regex: '^(\\d{6})$' }
  },
  {
    name: {
      common: 'Nepal',
      official: 'Federal Democratic Republic of Nepal',
      nativeName: {
        nep: { official: 'नेपाल संघीय लोकतान्त्रिक गणतन्त्र', common: 'नेपाल' }
      }
    },
    tld: ['.np'],
    cca2: 'NP',
    ccn3: '524',
    cca3: 'NPL',
    cioc: 'NEP',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { NPR: { name: 'Nepalese rupee', symbol: '₨' } },
    idd: { root: '+9', suffixes: ['77'] },
    capital: ['Kathmandu'],
    altSpellings: [
      'NP',
      'Federal Democratic Republic of Nepal',
      'Loktāntrik Ganatantra Nepāl'
    ],
    region: 'Asia',
    subregion: 'Southern Asia',
    languages: { nep: 'Nepali' },
    translations: {
      ara: { official: 'جمهورية نيبال الديمقراطية الاتحادية', common: 'نيبال' },
      bre: { official: 'Republik Demokratel Kevreadel Nepal', common: 'Nepal' },
      ces: {
        official: 'Federativní demokratická republika Nepál',
        common: 'Nepál'
      },
      cym: {
        official: 'Federal Democratic Republic of Nepal',
        common: 'Nepal'
      },
      deu: { official: 'Demokratische Bundesrepublik Nepal', common: 'Nepal' },
      est: { official: 'Nepali Demokraatlik Liitvabariik', common: 'Nepal' },
      fin: {
        official: 'Nepalin demokraattinen liittotasavalta',
        common: 'Nepal'
      },
      fra: { official: 'République du Népal', common: 'Népal' },
      hrv: { official: 'Savezna Demokratska Republika Nepal', common: 'Nepal' },
      hun: {
        official: 'Nepáli Szövetségi Demokratikus Köztársaság',
        common: 'Nepál'
      },
      ita: {
        official: 'Repubblica federale democratica del Nepal',
        common: 'Nepal'
      },
      jpn: { official: 'ネパール連邦民主共和国', common: 'ネパール' },
      kor: { official: '네팔 연방 민주 공화국', common: '네팔' },
      nld: {
        official: 'Federale Democratische Republiek Nepal',
        common: 'Nepal'
      },
      per: { official: 'جمهوری فدرال دموکراتیک نپال', common: 'نپال' },
      pol: {
        official: 'Federalna Demokratyczna Republika Nepalu',
        common: 'Nepal'
      },
      por: {
        official: 'República Democrática Federal do Nepal',
        common: 'Nepal'
      },
      rus: {
        official: 'Федеративная Демократическая Республика Непал',
        common: 'Непал'
      },
      slk: {
        official: 'Nepálska federatívna demokratická republika',
        common: 'Nepál'
      },
      spa: {
        official: 'República Democrática Federal de Nepal',
        common: 'Nepal'
      },
      swe: {
        official: 'Demokratiska förbundsrepubliken Nepal',
        common: 'Nepal'
      },
      tur: {
        official: 'Nepal Federal Demokratik Cumhuriyeti',
        common: 'Nepal'
      },
      urd: { official: 'وفاقی جمہوری جمہوریہ نیپال', common: 'نیپال' },
      zho: { official: '尼泊尔联邦民主共和国', common: '尼泊尔' }
    },
    latlng: [28.0, 84.0],
    landlocked: true,
    borders: ['CHN', 'IND'],
    area: 147181.0,
    demonyms: {
      eng: { f: 'Nepalese', m: 'Nepalese' },
      fra: { f: 'Népalaise', m: 'Népalais' }
    },
    flag: '\uD83C\uDDF3\uD83C\uDDF5',
    maps: {
      googleMaps: 'https://goo.gl/maps/UMj2zpbQp7B5c3yT7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/184633'
    },
    population: 29136808,
    gini: { 2010: 32.8 },
    fifa: 'NEP',
    car: { signs: ['NEP'], side: 'left' },
    timezones: ['UTC+05:45'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/np.png',
      svg: 'https://flagcdn.com/np.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/np.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/np.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [27.72, 85.32] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Pakistan',
      official: 'Islamic Republic of Pakistan',
      nativeName: {
        eng: { official: 'Islamic Republic of Pakistan', common: 'Pakistan' },
        urd: { official: 'اسلامی جمہوریۂ پاكستان', common: 'پاكستان' }
      }
    },
    tld: ['.pk'],
    cca2: 'PK',
    ccn3: '586',
    cca3: 'PAK',
    cioc: 'PAK',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { PKR: { name: 'Pakistani rupee', symbol: '₨' } },
    idd: { root: '+9', suffixes: ['2'] },
    capital: ['Islamabad'],
    altSpellings: [
      'PK',
      'Pākistān',
      'Islamic Republic of Pakistan',
      "Islāmī Jumhūriya'eh Pākistān"
    ],
    region: 'Asia',
    subregion: 'Southern Asia',
    languages: { eng: 'English', urd: 'Urdu' },
    translations: {
      ara: { official: 'جمهورية باكستان الإسلامية', common: 'باكستان' },
      bre: { official: 'Republik islamek Pakistan', common: 'Pakistan' },
      ces: { official: 'Pákistánská islámská republika', common: 'Pákistán' },
      cym: { official: 'Islamic Republic of Pakistan', common: 'Pakistan' },
      deu: { official: 'Islamische Republik Pakistan', common: 'Pakistan' },
      est: { official: 'Pakistani Islamivabariik', common: 'Pakistan' },
      fin: {
        official: 'Pakistanin islamilainen tasavalta',
        common: 'Pakistan'
      },
      fra: { official: 'République islamique du Pakistan', common: 'Pakistan' },
      hrv: { official: 'Islamska Republika Pakistan', common: 'Pakistan' },
      hun: { official: 'Pakisztán', common: 'Pakisztán' },
      ita: { official: 'Repubblica islamica del Pakistan', common: 'Pakistan' },
      jpn: { official: 'パキスタン', common: 'パキスタン' },
      kor: { official: '파키스탄 이슬람 공화국', common: '파키스탄' },
      nld: { official: 'Islamitische Republiek Pakistan', common: 'Pakistan' },
      per: { official: 'جمهوری اسلامی پاکستان', common: 'پاکستان' },
      pol: { official: 'Islamska Republika Pakistanu', common: 'Pakistan' },
      por: { official: 'República Islâmica do Paquistão', common: 'Paquistão' },
      rus: { official: 'Исламская Республика Пакистан', common: 'Пакистан' },
      slk: { official: 'Pakistanská islamská republika', common: 'Pakistan' },
      spa: { official: 'República Islámica de Pakistán', common: 'Pakistán' },
      swe: { official: 'Islamiska republiken Pakistan', common: 'Pakistan' },
      tur: { official: 'Pakistan İslam Cumhuriyeti', common: 'Pakistan' },
      urd: { official: 'اسلامی جمہوریہ پاکستان', common: 'پاکستان' },
      zho: { official: '巴基斯坦伊斯兰共和国', common: '巴基斯坦' }
    },
    latlng: [30.0, 70.0],
    landlocked: false,
    borders: ['AFG', 'CHN', 'IND', 'IRN'],
    area: 881912.0,
    demonyms: {
      eng: { f: 'Pakistani', m: 'Pakistani' },
      fra: { f: 'Pakistanaise', m: 'Pakistanais' }
    },
    flag: '\uD83C\uDDF5\uD83C\uDDF0',
    maps: {
      googleMaps: 'https://goo.gl/maps/5LYujdfR5yLUXoERA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/307573'
    },
    population: 220892331,
    gini: { 2018: 31.6 },
    fifa: 'PAK',
    car: { signs: ['PK'], side: 'left' },
    timezones: ['UTC+05:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/pk.png',
      svg: 'https://flagcdn.com/pk.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/pk.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/pk.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [33.68, 73.05] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Singapore',
      official: 'Republic of Singapore',
      nativeName: {
        zho: { official: '新加坡共和国', common: '新加坡' },
        eng: { official: 'Republic of Singapore', common: 'Singapore' },
        msa: { official: 'Republik Singapura', common: 'Singapura' },
        tam: { official: 'சிங்கப்பூர் குடியரசு', common: 'சிங்கப்பூர்' }
      }
    },
    tld: ['.sg', '.新加坡', '.சிங்கப்பூர்'],
    cca2: 'SG',
    ccn3: '702',
    cca3: 'SGP',
    cioc: 'SGP',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { SGD: { name: 'Singapore dollar', symbol: '$' } },
    idd: { root: '+6', suffixes: ['5'] },
    capital: ['Singapore'],
    altSpellings: ['SG', 'Singapura', 'Republik Singapura', '新加坡共和国'],
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    languages: { zho: 'Chinese', eng: 'English', msa: 'Malay', tam: 'Tamil' },
    translations: {
      ara: { official: 'جمهورية سنغافورة', common: 'سنغافورة' },
      bre: { official: 'Republik Singapour', common: 'Singapour' },
      ces: { official: 'Singapurská republika', common: 'Singapur' },
      cym: { official: 'Republic of Singapore', common: 'Singapore' },
      deu: { official: 'Republik Singapur', common: 'Singapur' },
      est: { official: 'Singapuri Vabariik', common: 'Singapur' },
      fin: { official: 'Singaporen tasavalta', common: 'Singapore' },
      fra: { official: 'République de Singapour', common: 'Singapour' },
      hrv: { official: 'Republika Singapur', common: 'Singapur' },
      hun: { official: 'Szingapúri Köztársaság', common: 'Szingapúr' },
      ita: { official: 'Repubblica di Singapore', common: 'Singapore' },
      jpn: { official: 'シンガポール共和国', common: 'シンガポール' },
      kor: { official: '싱가포르 공화국', common: '싱가포르' },
      nld: { official: 'Republiek Singapore', common: 'Singapore' },
      per: { official: 'جمهوری سنگاپور', common: 'سنگاپور' },
      pol: { official: 'Republika Singapuru', common: 'Singapur' },
      por: { official: 'República de Singapura', common: 'Singapura' },
      rus: { official: 'Республика Сингапур', common: 'Сингапур' },
      slk: { official: 'Singapurská republika', common: 'Singapur' },
      spa: { official: 'República de Singapur', common: 'Singapur' },
      swe: { official: 'Republiken Singapore', common: 'Singapore' },
      tur: { official: 'Singapur Cumhuriyeti', common: 'Singapur' },
      urd: { official: 'جمہوریہ سنگاپور', common: 'سنگاپور' }
    },
    latlng: [1.36666666, 103.8],
    landlocked: false,
    area: 710.0,
    demonyms: {
      eng: { f: 'Singaporean', m: 'Singaporean' },
      fra: { f: 'Singapourienne', m: 'Singapourien' }
    },
    flag: '\uD83C\uDDF8\uD83C\uDDEC',
    maps: {
      googleMaps: 'https://goo.gl/maps/QbQt9Y9b5KFzsahV6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/536780'
    },
    population: 5685807,
    fifa: 'SIN',
    car: { signs: ['SGP'], side: 'left' },
    timezones: ['UTC+08:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/sg.png',
      svg: 'https://flagcdn.com/sg.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/sg.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/sg.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [1.28, 103.85] },
    postalCode: { format: '######', regex: '^(\\d{6})$' }
  },
  {
    name: {
      common: 'Japan',
      official: 'Japan',
      nativeName: { jpn: { official: '日本', common: '日本' } }
    },
    tld: ['.jp', '.みんな'],
    cca2: 'JP',
    ccn3: '392',
    cca3: 'JPN',
    cioc: 'JPN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { JPY: { name: 'Japanese yen', symbol: '¥' } },
    idd: { root: '+8', suffixes: ['1'] },
    capital: ['Tokyo'],
    altSpellings: ['JP', 'Nippon', 'Nihon'],
    region: 'Asia',
    subregion: 'Eastern Asia',
    languages: { jpn: 'Japanese' },
    translations: {
      ara: { official: 'اليابان', common: 'اليابان' },
      bre: { official: 'Japan', common: 'Japan' },
      ces: { official: 'Japonsko', common: 'Japonsko' },
      cym: { official: 'Japan', common: 'Japan' },
      deu: { official: 'Japan', common: 'Japan' },
      est: { official: 'Jaapan', common: 'Jaapan' },
      fin: { official: 'Japani', common: 'Japani' },
      fra: { official: 'Japon', common: 'Japon' },
      hrv: { official: 'Japan', common: 'Japan' },
      hun: { official: 'Japán', common: 'Japán' },
      ita: { official: 'Giappone', common: 'Giappone' },
      jpn: { official: '日本', common: '日本' },
      kor: { official: '일본국', common: '일본' },
      nld: { official: 'Japan', common: 'Japan' },
      per: { official: 'ژاپن', common: 'ژاپن' },
      pol: { official: 'Japonia', common: 'Japonia' },
      por: { official: 'Japão', common: 'Japão' },
      rus: { official: 'Япония', common: 'Япония' },
      slk: { official: 'Japonsko', common: 'Japonsko' },
      spa: { official: 'Japón', common: 'Japón' },
      swe: { official: 'Japan', common: 'Japan' },
      tur: { official: 'Japonya', common: 'Japonya' },
      urd: { official: 'جاپان', common: 'جاپان' },
      zho: { official: '日本国', common: '日本' }
    },
    latlng: [36.0, 138.0],
    landlocked: false,
    area: 377930.0,
    demonyms: {
      eng: { f: 'Japanese', m: 'Japanese' },
      fra: { f: 'Japonaise', m: 'Japonais' }
    },
    flag: '\uD83C\uDDEF\uD83C\uDDF5',
    maps: {
      googleMaps: 'https://goo.gl/maps/NGTLSCSrA8bMrvnX9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/382313'
    },
    population: 125836021,
    gini: { 2013: 32.9 },
    fifa: 'JPN',
    car: { signs: ['J'], side: 'left' },
    timezones: ['UTC+09:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/jp.png',
      svg: 'https://flagcdn.com/jp.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/jp.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/jp.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [35.68, 139.75] },
    postalCode: { format: '###-####', regex: '^(\\d{7})$' }
  },
  {
    name: {
      common: 'Vietnam',
      official: 'Socialist Republic of Vietnam',
      nativeName: {
        vie: {
          official: 'Cộng hòa xã hội chủ nghĩa Việt Nam',
          common: 'Việt Nam'
        }
      }
    },
    tld: ['.vn'],
    cca2: 'VN',
    ccn3: '704',
    cca3: 'VNM',
    cioc: 'VIE',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { VND: { name: 'Vietnamese đồng', symbol: '₫' } },
    idd: { root: '+8', suffixes: ['4'] },
    capital: ['Hanoi'],
    altSpellings: [
      'VN',
      'Socialist Republic of Vietnam',
      'Cộng hòa Xã hội chủ nghĩa Việt Nam',
      'Viet Nam'
    ],
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    languages: { vie: 'Vietnamese' },
    translations: {
      ara: { official: 'جمهورية فيتنام الاشتراكية', common: 'فيتنام' },
      bre: { official: 'Republik Sokialour Viêt Nam', common: 'Viêt Nam' },
      ces: {
        official: 'Vietnamská socialistická republika',
        common: 'Vietnam'
      },
      cym: { official: 'Socialist Republic of Vietnam', common: 'Vietnam' },
      deu: { official: 'Sozialistische Republik Vietnam', common: 'Vietnam' },
      est: { official: 'Vietnami Sotsialistlik Vabariik', common: 'Vietnam' },
      fin: { official: 'Vietnamin sosialistinen tasavalta', common: 'Vietnam' },
      fra: {
        official: 'République socialiste du Viêt Nam',
        common: 'Viêt Nam'
      },
      hrv: {
        official: 'Socijalistička Republika Vijetnam',
        common: 'Vijetnam'
      },
      hun: { official: 'Vietnámi Szocialista Köztársaság', common: 'Vietnám' },
      ita: { official: 'Repubblica socialista del Vietnam', common: 'Vietnam' },
      jpn: { official: 'ベトナム社会主義共和国', common: 'ベトナム' },
      kor: { official: '베트남 사회주의 공화국', common: '베트남' },
      nld: { official: 'Socialistische Republiek Vietnam', common: 'Vietnam' },
      per: { official: 'جمهوری سوسیالیستی ویتنام', common: 'ویتنام' },
      pol: { official: 'Socjalistyczna Republika Wietnamu', common: 'Wietnam' },
      por: { official: 'República Socialista do Vietname', common: 'Vietname' },
      rus: {
        official: 'Социалистическая Республика Вьетнам',
        common: 'Вьетнам'
      },
      slk: {
        official: 'Vietnamská socialistická republika',
        common: 'Vietnam'
      },
      spa: { official: 'República Socialista de Vietnam', common: 'Vietnam' },
      swe: { official: 'Socialistiska republiken Vietnam', common: 'Vietnam' },
      tur: { official: 'Vietnam Sosyalist Cumhuriyeti', common: 'Vietnam' },
      urd: { official: 'اشتراکی جمہوریہ ویتنام', common: 'ویتنام' },
      zho: { official: '越南社会主义共和国', common: '越南' }
    },
    latlng: [16.16666666, 107.83333333],
    landlocked: false,
    borders: ['KHM', 'CHN', 'LAO'],
    area: 331212.0,
    demonyms: {
      eng: { f: 'Vietnamese', m: 'Vietnamese' },
      fra: { f: 'Vietnamienne', m: 'Vietnamien' }
    },
    flag: '\uD83C\uDDFB\uD83C\uDDF3',
    maps: {
      googleMaps: 'https://goo.gl/maps/PCpVt9WzdJ9A9nEZ9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/49915'
    },
    population: 97338583,
    gini: { 2018: 35.7 },
    fifa: 'VIE',
    car: { signs: ['VN'], side: 'right' },
    timezones: ['UTC+07:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/vn.png',
      svg: 'https://flagcdn.com/vn.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/vn.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/vn.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [21.03, 105.85] },
    postalCode: { format: '######', regex: '^(\\d{6})$' }
  },
  {
    name: {
      common: 'Kazakhstan',
      official: 'Republic of Kazakhstan',
      nativeName: {
        kaz: { official: 'Қазақстан Республикасы', common: 'Қазақстан' },
        rus: { official: 'Республика Казахстан', common: 'Казахстан' }
      }
    },
    tld: ['.kz', '.қаз'],
    cca2: 'KZ',
    ccn3: '398',
    cca3: 'KAZ',
    cioc: 'KAZ',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { KZT: { name: 'Kazakhstani tenge', symbol: '₸' } },
    idd: { root: '+7', suffixes: ['6', '7'] },
    capital: ['Nur-Sultan'],
    altSpellings: [
      'KZ',
      'Qazaqstan',
      'Казахстан',
      'Republic of Kazakhstan',
      'Қазақстан Республикасы',
      'Qazaqstan Respublïkası',
      'Республика Казахстан',
      'Respublika Kazakhstan'
    ],
    region: 'Asia',
    subregion: 'Central Asia',
    languages: { kaz: 'Kazakh', rus: 'Russian' },
    translations: {
      ara: { official: 'جمهورية كازاخستان', common: 'كازاخستان' },
      bre: { official: 'Republik Kazakstan', common: 'Kazakstan' },
      ces: { official: 'Republika Kazachstán', common: 'Kazachstán' },
      cym: { official: 'Republic of Kazakhstan', common: 'Kazakhstan' },
      deu: { official: 'Republik Kasachstan', common: 'Kasachstan' },
      est: { official: 'Kasahstani Vabariik', common: 'Kasahstan' },
      fin: { official: 'Kazakstanin tasavalta', common: 'Kazakstan' },
      fra: { official: 'République du Kazakhstan', common: 'Kazakhstan' },
      hrv: { official: 'Republika Kazahstan', common: 'Kazahstan' },
      hun: { official: 'Kazah Köztársaság', common: 'Kazahsztán' },
      ita: { official: 'Repubblica del Kazakhstan', common: 'Kazakistan' },
      jpn: { official: 'カザフスタン共和国', common: 'カザフスタン' },
      kor: { official: '카자흐스탄 공화국', common: '카자흐스탄' },
      nld: { official: 'Republiek Kazachstan', common: 'Kazachstan' },
      per: { official: 'جمهوری قزاقستان', common: 'قزاقستان' },
      pol: { official: 'Republika Kazachstanu', common: 'Kazachstan' },
      por: { official: 'República do Cazaquistão', common: 'Cazaquistão' },
      rus: { official: 'Республика Казахстан', common: 'Казахстан' },
      slk: { official: 'Kazašská republika', common: 'Kazachstan' },
      spa: { official: 'República de Kazajstán', common: 'Kazajistán' },
      swe: { official: 'Republiken Kazakstan', common: 'Kazakstan' },
      tur: { official: 'Kazakistan Cumhuriyeti', common: 'Kazakistan' },
      urd: { official: 'جمہوریہ قازقستان', common: 'قازقستان' },
      zho: { official: '哈萨克斯坦共和国', common: '哈萨克斯坦' }
    },
    latlng: [48.0, 68.0],
    landlocked: true,
    borders: ['CHN', 'KGZ', 'RUS', 'TKM', 'UZB'],
    area: 2724900.0,
    demonyms: {
      eng: { f: 'Kazakhstani', m: 'Kazakhstani' },
      fra: { f: 'Kazakhstanaise', m: 'Kazakhstanais' }
    },
    flag: '\uD83C\uDDF0\uD83C\uDDFF',
    maps: {
      googleMaps: 'https://goo.gl/maps/8VohJGu7ShuzZYyeA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/214665'
    },
    population: 18754440,
    gini: { 2018: 27.8 },
    fifa: 'KAZ',
    car: { signs: ['KZ'], side: 'right' },
    timezones: ['UTC+05:00', 'UTC+06:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/kz.png',
      svg: 'https://flagcdn.com/kz.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/kz.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/kz.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [51.16, 71.45] },
    postalCode: { format: '######', regex: '^(\\d{6})$' }
  },
  {
    name: {
      common: 'Bangladesh',
      official: "People's Republic of Bangladesh",
      nativeName: {
        ben: { official: 'বাংলাদেশ গণপ্রজাতন্ত্রী', common: 'বাংলাদেশ' }
      }
    },
    tld: ['.bd'],
    cca2: 'BD',
    ccn3: '050',
    cca3: 'BGD',
    cioc: 'BAN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { BDT: { name: 'Bangladeshi taka', symbol: '৳' } },
    idd: { root: '+8', suffixes: ['80'] },
    capital: ['Dhaka'],
    altSpellings: [
      'BD',
      "People's Republic of Bangladesh",
      'Gônôprôjatôntri Bangladesh'
    ],
    region: 'Asia',
    subregion: 'Southern Asia',
    languages: { ben: 'Bengali' },
    translations: {
      ara: { official: 'جمهورية بنغلاديش الشعبية', common: 'بنغلاديش' },
      bre: { official: 'Republik pobl Bangladesh', common: 'Bangladesh' },
      ces: { official: 'Bangladéšská lidová republika', common: 'Bangladéš' },
      cym: { official: 'Gweriniaeth Pobl Bangladesh', common: 'Bangladesh' },
      deu: { official: 'Volksrepublik Bangladesch', common: 'Bangladesch' },
      est: { official: 'Bangladeshi Rahvavabariik', common: 'Bangladesh' },
      fin: { official: 'Bangladeshin kansantasavalta', common: 'Bangladesh' },
      fra: {
        official: 'La République populaire du Bangladesh',
        common: 'Bangladesh'
      },
      hrv: { official: 'Narodna Republika Bangladeš', common: 'Bangladeš' },
      hun: { official: 'Banglades', common: 'Banglades' },
      ita: {
        official: 'Repubblica popolare del Bangladesh',
        common: 'Bangladesh'
      },
      jpn: { official: 'バングラデシュ人民共和国', common: 'バングラデシュ' },
      kor: { official: '방글라데시 인민 공화국', common: '방글라데시' },
      nld: { official: 'Volksrepubliek Bangladesh', common: 'Bangladesh' },
      per: { official: 'جمهوری خلق بنگلادش', common: 'بنگلادش' },
      pol: { official: 'Ludowa Republika Bangladeszu', common: 'Bangladesz' },
      por: {
        official: 'República Popular do Bangladesh',
        common: 'Bangladesh'
      },
      rus: { official: 'Народная Республика Бангладеш', common: 'Бангладеш' },
      slk: { official: 'Bangladéšska ľudová republika', common: 'Bangladéš' },
      spa: {
        official: 'República Popular de Bangladesh',
        common: 'Bangladesh'
      },
      swe: { official: 'Folkrepubliken Bangladesh', common: 'Bangladesh' },
      tur: { official: 'Bangladeş Halk Cumhuriyeti', common: 'Bangladeş' },
      urd: { official: 'عوامی جمہوریہ بنگلہ دیش', common: 'بنگلہ دیش' },
      zho: { official: '孟加拉人民共和国', common: '孟加拉国' }
    },
    latlng: [24.0, 90.0],
    landlocked: false,
    borders: ['MMR', 'IND'],
    area: 147570.0,
    demonyms: {
      eng: { f: 'Bangladeshi', m: 'Bangladeshi' },
      fra: { f: 'Bangladaise', m: 'Bangladais' }
    },
    flag: '\uD83C\uDDE7\uD83C\uDDE9',
    maps: {
      googleMaps: 'https://goo.gl/maps/op6gmLbHcvv6rLhH6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/184640'
    },
    population: 164689383,
    gini: { 2016: 32.4 },
    fifa: 'BAN',
    car: { signs: ['BD'], side: 'left' },
    timezones: ['UTC+06:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/bd.png',
      svg: 'https://flagcdn.com/bd.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/bd.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/bd.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [23.72, 90.4] },
    postalCode: { format: '####', regex: '^(\\d{4})$' }
  },
  {
    name: {
      common: 'Indonesia',
      official: 'Republic of Indonesia',
      nativeName: {
        ind: { official: 'Republik Indonesia', common: 'Indonesia' }
      }
    },
    tld: ['.id'],
    cca2: 'ID',
    ccn3: '360',
    cca3: 'IDN',
    cioc: 'INA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { IDR: { name: 'Indonesian rupiah', symbol: 'Rp' } },
    idd: { root: '+6', suffixes: ['2'] },
    capital: ['Jakarta'],
    altSpellings: ['ID', 'Republic of Indonesia', 'Republik Indonesia'],
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    languages: { ind: 'Indonesian' },
    translations: {
      ara: { official: 'جمهورية إندونيسيا', common: 'إندونيسيا' },
      bre: { official: 'Republik Indonezia', common: 'Indonezia' },
      ces: { official: 'Indonéská republika', common: 'Indonésie' },
      cym: { official: 'Republic of Indonesia', common: 'Indonesia' },
      deu: { official: 'Republik Indonesien', common: 'Indonesien' },
      est: { official: 'Indoneesia Vabariik', common: 'Indoneesia' },
      fin: { official: 'Indonesian tasavalta', common: 'Indonesia' },
      fra: { official: "République d'Indonésie", common: 'Indonésie' },
      hrv: { official: 'Republika Indonezija', common: 'Indonezija' },
      hun: { official: 'Indonéz Köztársaság', common: 'Indonézia' },
      ita: { official: 'Repubblica di Indonesia', common: 'Indonesia' },
      jpn: { official: 'インドネシア共和国', common: 'インドネシア' },
      kor: { official: '인도네시아 공화국', common: '인도네시아' },
      nld: { official: 'Republiek Indonesië', common: 'Indonesië' },
      per: { official: 'جمهوری اندونزی', common: 'اندونزی' },
      pol: { official: 'Republika Indonezji', common: 'Indonezja' },
      por: { official: 'República da Indonésia', common: 'Indonésia' },
      rus: { official: 'Республика Индонезия', common: 'Индонезия' },
      slk: { official: 'Indonézska republika', common: 'Indonézia' },
      spa: { official: 'República de Indonesia', common: 'Indonesia' },
      swe: { official: 'Republiken Indonesien', common: 'Indonesien' },
      tur: { official: 'Endonezya Cumhuriyeti', common: 'Endonezya' },
      urd: { official: 'جمہوریہ انڈونیشیا', common: 'انڈونیشیا' },
      zho: { official: '印度尼西亚共和国', common: '印度尼西亚' }
    },
    latlng: [-5.0, 120.0],
    landlocked: false,
    borders: ['TLS', 'MYS', 'PNG'],
    area: 1904569.0,
    demonyms: {
      eng: { f: 'Indonesian', m: 'Indonesian' },
      fra: { f: 'Indonésienne', m: 'Indonésien' }
    },
    flag: '\uD83C\uDDEE\uD83C\uDDE9',
    maps: {
      googleMaps: 'https://goo.gl/maps/9gfPupm5bffixiFJ6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/21335'
    },
    population: 273523621,
    gini: { 2019: 38.2 },
    fifa: 'IDN',
    car: { signs: ['RI'], side: 'left' },
    timezones: ['UTC+07:00', 'UTC+08:00', 'UTC+09:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/id.png',
      svg: 'https://flagcdn.com/id.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/id.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/id.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-6.17, 106.82] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Armenia',
      official: 'Republic of Armenia',
      nativeName: {
        hye: { official: 'Հայաստանի Հանրապետություն', common: 'Հայաստան' }
      }
    },
    tld: ['.am'],
    cca2: 'AM',
    ccn3: '051',
    cca3: 'ARM',
    cioc: 'ARM',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { AMD: { name: 'Armenian dram', symbol: '֏' } },
    idd: { root: '+3', suffixes: ['74'] },
    capital: ['Yerevan'],
    altSpellings: [
      'AM',
      'Hayastan',
      'Republic of Armenia',
      'Հայաստանի Հանրապետություն'
    ],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { hye: 'Armenian' },
    translations: {
      ara: { official: 'جمهورية أرمينيا', common: 'أرمينيا' },
      bre: { official: 'Republik Armenia', common: 'Armenia' },
      ces: { official: 'Arménská republika', common: 'Arménie' },
      cym: { official: 'Gweriniaeth Armenia', common: 'Armenia' },
      deu: { official: 'Republik Armenien', common: 'Armenien' },
      est: { official: 'Armeenia Vabariik', common: 'Armeenia' },
      fin: { official: 'Armenian tasavalta', common: 'Armenia' },
      fra: { official: "République d'Arménie", common: 'Arménie' },
      hrv: { official: 'Republika Armenija', common: 'Armenija' },
      hun: { official: 'Örményország', common: 'Örményország' },
      ita: { official: 'Repubblica di Armenia', common: 'Armenia' },
      jpn: { official: 'アルメニア共和国', common: 'アルメニア' },
      kor: { official: '아르메니아 공화국', common: '아르메니아' },
      nld: { official: 'Republiek Armenië', common: 'Armenië' },
      per: { official: 'جمهوری ارمنستان', common: 'ارمنستان' },
      pol: { official: 'Republika Armenii', common: 'Armenia' },
      por: { official: 'República da Arménia', common: 'Arménia' },
      rus: { official: 'Республика Армения', common: 'Армения' },
      slk: { official: 'Arménska republika', common: 'Arménsko' },
      spa: { official: 'República de Armenia', common: 'Armenia' },
      swe: { official: 'Republiken Armenien', common: 'Armenien' },
      tur: { official: 'Ermenistan Cumhuriyeti', common: 'Ermenistan' },
      urd: { official: 'جمہوریہ آرمینیا', common: 'آرمینیا' },
      zho: { official: '亚美尼亚共和国', common: '亚美尼亚' }
    },
    latlng: [40.0, 45.0],
    landlocked: true,
    borders: ['AZE', 'GEO', 'IRN', 'TUR'],
    area: 29743.0,
    demonyms: {
      eng: { f: 'Armenian', m: 'Armenian' },
      fra: { f: 'Arménienne', m: 'Arménien' }
    },
    flag: '\uD83C\uDDE6\uD83C\uDDF2',
    maps: {
      googleMaps: 'https://goo.gl/maps/azWUtK9bUQYEyccbA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/364066'
    },
    population: 2963234,
    gini: { 2019: 29.9 },
    fifa: 'ARM',
    car: { signs: ['AM'], side: 'right' },
    timezones: ['UTC+04:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/am.png',
      svg: 'https://flagcdn.com/am.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/am.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/am.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [40.17, 44.5] },
    postalCode: { format: '######', regex: '^(\\d{6})$' }
  },
  {
    name: {
      common: 'Syria',
      official: 'Syrian Arab Republic',
      nativeName: {
        ara: { official: 'الجمهورية العربية السورية', common: 'سوريا' }
      }
    },
    tld: ['.sy', 'سوريا.'],
    cca2: 'SY',
    ccn3: '760',
    cca3: 'SYR',
    cioc: 'SYR',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { SYP: { name: 'Syrian pound', symbol: '£' } },
    idd: { root: '+9', suffixes: ['63'] },
    capital: ['Damascus'],
    altSpellings: [
      'SY',
      'Syrian Arab Republic',
      'Al-Jumhūrīyah Al-ʻArabīyah As-Sūrīyah'
    ],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { ara: 'Arabic' },
    translations: {
      ara: { official: 'الجمهورية العربية السورية', common: 'سوريا' },
      bre: { official: 'Republik Arab Siriat', common: 'Siria' },
      ces: { official: 'Syrská arabská republika', common: 'Sýrie' },
      cym: { official: 'Syrian Arab Republic', common: 'Syria' },
      deu: { official: 'Arabische Republik Syrien', common: 'Syrien' },
      est: { official: 'Süüria Araabia Vabariik', common: 'Süüria' },
      fin: { official: 'Syyrian arabitasavalta', common: 'Syyria' },
      fra: { official: 'République arabe syrienne', common: 'Syrie' },
      hrv: { official: 'Sirijska Arapska Republika', common: 'Sirija' },
      hun: { official: 'Szíriai Arab Köztársaság', common: 'Szíria' },
      ita: { official: 'Repubblica araba siriana', common: 'Siria' },
      jpn: { official: 'シリアアラブ共和国', common: 'シリア・アラブ共和国' },
      kor: { official: '시리아 아랍 공화국', common: '시리아' },
      nld: { official: 'Syrische Arabische Republiek', common: 'Syrië' },
      per: { official: 'جمهوری عربی سوریه', common: 'سوریه' },
      pol: { official: 'Syryjska Republika Arabska', common: 'Syria' },
      por: { official: 'República Árabe Síria', common: 'Síria' },
      rus: { official: 'Сирийская Арабская Республика', common: 'Сирия' },
      slk: { official: 'Sýrska arabská republika', common: 'Sýria' },
      spa: { official: 'República Árabe Siria', common: 'Siria' },
      swe: { official: 'Syriska arabiska republiken', common: 'Syrien' },
      tur: { official: 'Suriye Arap Cumhuriyeti', common: 'Suriye' },
      urd: { official: 'عرب جمہوریہ سوریہ', common: 'سوریہ' },
      zho: { official: '叙利亚阿拉伯共和国', common: '叙利亚' }
    },
    latlng: [35.0, 38.0],
    landlocked: false,
    borders: ['IRQ', 'ISR', 'JOR', 'LBN', 'TUR'],
    area: 185180.0,
    demonyms: {
      eng: { f: 'Syrian', m: 'Syrian' },
      fra: { f: 'Syrienne', m: 'Syrien' }
    },
    flag: '\uD83C\uDDF8\uD83C\uDDFE',
    maps: {
      googleMaps: 'https://goo.gl/maps/Xe3VnFbwdb4nv2SM9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/184840'
    },
    population: 17500657,
    gini: { 2003: 37.5 },
    fifa: 'SYR',
    car: { signs: ['SYR'], side: 'right' },
    timezones: ['UTC+02:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/sy.png',
      svg: 'https://flagcdn.com/sy.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/sy.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/sy.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [33.5, 36.3] }
  },
  {
    name: {
      common: 'Myanmar',
      official: 'Republic of the Union of Myanmar',
      nativeName: {
        mya: {
          official: 'ပြည်ထောင်စု သမ္မတ မြန်မာနိုင်ငံတော်',
          common: 'မြန်မာ'
        }
      }
    },
    tld: ['.mm'],
    cca2: 'MM',
    ccn3: '104',
    cca3: 'MMR',
    cioc: 'MYA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { MMK: { name: 'Burmese kyat', symbol: 'Ks' } },
    idd: { root: '+9', suffixes: ['5'] },
    capital: ['Naypyidaw'],
    altSpellings: [
      'MM',
      'Burma',
      'Republic of the Union of Myanmar',
      'Pyidaunzu Thanmăda Myăma Nainngandaw'
    ],
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    languages: { mya: 'Burmese' },
    translations: {
      ara: { official: 'جمهورية اتحاد ميانمار', common: 'ميانمار' },
      bre: { official: 'Republik Unaniezh Myanmar', common: 'Myanmar' },
      ces: { official: 'Republika Myanmarský svaz', common: 'Myanmar' },
      cym: { official: 'Republic of the Union of Myanmar', common: 'Myanmar' },
      deu: { official: 'Republik der Union Myanmar', common: 'Myanmar' },
      est: { official: 'Myanmari Liidu Vabariik', common: 'Myanmar' },
      fin: { official: 'Myanmarin liiton tasavalta', common: 'Myanmar' },
      fra: { official: "République de l'Union du Myanmar", common: 'Birmanie' },
      hrv: { official: 'Republika Unije Mijanmar', common: 'Mijanmar' },
      hun: {
        official: 'Mianmari Államszövetség Köztársasága',
        common: 'Mianmar'
      },
      ita: {
        official: "Repubblica dell'Unione di Myanmar",
        common: 'Birmania'
      },
      jpn: { official: 'ミャンマー連邦共和国', common: 'ミャンマー' },
      kor: { official: '미얀마 연방 공화국', common: '미얀마' },
      nld: { official: 'Republiek van de Unie van Myanmar', common: 'Myanmar' },
      per: { official: 'اتحادیه جمهوری میانمار', common: 'میانمار' },
      pol: { official: 'Republika Związku Mjanmy', common: 'Mjanma' },
      por: { official: 'República da União de Myanmar', common: 'Myanmar' },
      rus: { official: 'Республика Союза Мьянма', common: 'Мьянма' },
      slk: { official: 'Mjanmarská zväzová republika', common: 'Mjanmarsko' },
      spa: { official: 'República de la Unión de Myanmar', common: 'Myanmar' },
      swe: { official: 'Republiken Unionen Myanmar', common: 'Myanmar' },
      tur: { official: 'Myanmar Birliği Cumhuriyeti', common: 'Myanmar' },
      urd: { official: 'متحدہ جمہوریہ میانمار', common: 'میانمار' },
      zho: { official: '缅甸联邦共和国', common: '缅甸' }
    },
    latlng: [22.0, 98.0],
    landlocked: false,
    borders: ['BGD', 'CHN', 'IND', 'LAO', 'THA'],
    area: 676578.0,
    demonyms: {
      eng: { f: 'Burmese', m: 'Burmese' },
      fra: { f: 'Birmane', m: 'Birman' }
    },
    flag: '\uD83C\uDDF2\uD83C\uDDF2',
    maps: {
      googleMaps: 'https://goo.gl/maps/4jrZyJkDERUfHyp26',
      openStreetMaps: 'https://www.openstreetmap.org/relation/50371'
    },
    population: 54409794,
    gini: { 2017: 30.7 },
    fifa: 'MYA',
    car: { signs: ['BUR'], side: 'right' },
    timezones: ['UTC+06:30'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/mm.png',
      svg: 'https://flagcdn.com/mm.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/mm.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/mm.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [19.76, 96.07] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Turkmenistan',
      official: 'Turkmenistan',
      nativeName: {
        rus: { official: 'Туркменистан', common: 'Туркмения' },
        tuk: { official: 'Türkmenistan', common: 'Türkmenistan' }
      }
    },
    tld: ['.tm'],
    cca2: 'TM',
    ccn3: '795',
    cca3: 'TKM',
    cioc: 'TKM',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { TMT: { name: 'Turkmenistan manat', symbol: 'm' } },
    idd: { root: '+9', suffixes: ['93'] },
    capital: ['Ashgabat'],
    altSpellings: ['TM'],
    region: 'Asia',
    subregion: 'Central Asia',
    languages: { rus: 'Russian', tuk: 'Turkmen' },
    translations: {
      ara: { official: 'تركمانستان', common: 'تركمانستان' },
      bre: { official: 'Republik Turkmenistan', common: 'Turkmenistan' },
      ces: { official: 'Turkmenistán', common: 'Turkmenistán' },
      cym: { official: 'Turkmenistan', common: 'Turkmenistan' },
      deu: { official: 'Turkmenistan', common: 'Turkmenistan' },
      est: { official: 'Türkmenistan', common: 'Türkmenistan' },
      fin: { official: 'Turkmenistan', common: 'Turkmenistan' },
      fra: { official: 'Turkménistan', common: 'Turkménistan' },
      hrv: { official: 'Turkmenistan', common: 'Turkmenistan' },
      hun: { official: 'Türkmén Köztársaság', common: 'Türkmenisztán' },
      ita: { official: 'Turkmenistan', common: 'Turkmenistan' },
      jpn: { official: 'トルクメニスタン', common: 'トルクメニスタン' },
      kor: { official: '투르크메니스탄', common: '투르크메니스탄' },
      nld: { official: 'Turkmenistan', common: 'Turkmenistan' },
      per: { official: 'جمهوری خلق ترکمنستان', common: 'ترکمنستان' },
      pol: { official: 'Republika Turkmenistanu', common: 'Turkmenistan' },
      por: { official: 'Turcomenistão', common: 'Turquemenistão' },
      rus: { official: 'Туркменистан', common: 'Туркмения' },
      slk: { official: 'Turkménsko', common: 'Turkménsko' },
      spa: { official: 'Turkmenistán', common: 'Turkmenistán' },
      swe: { official: 'Turkmenistan', common: 'Turkmenistan' },
      tur: { official: 'Türkmenistan', common: 'Türkmenistan' },
      urd: { official: 'ترکمانستان', common: 'ترکمانستان' },
      zho: { official: '土库曼斯坦', common: '土库曼斯坦' }
    },
    latlng: [40.0, 60.0],
    landlocked: true,
    borders: ['AFG', 'IRN', 'KAZ', 'UZB'],
    area: 488100.0,
    demonyms: {
      eng: { f: 'Turkmen', m: 'Turkmen' },
      fra: { f: 'Turkmène', m: 'Turkmène' }
    },
    flag: '\uD83C\uDDF9\uD83C\uDDF2',
    maps: {
      googleMaps: 'https://goo.gl/maps/cgfUcaQHSWKuqeKk9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/223026'
    },
    population: 6031187,
    gini: { 1998: 40.8 },
    fifa: 'TKM',
    car: { signs: ['TM'], side: 'right' },
    timezones: ['UTC+05:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/tm.png',
      svg: 'https://flagcdn.com/tm.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/tm.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/tm.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [37.95, 58.38] },
    postalCode: { format: '######', regex: '^(\\d{6})$' }
  },
  {
    name: {
      common: 'Oman',
      official: 'Sultanate of Oman',
      nativeName: { ara: { official: 'سلطنة عمان', common: 'عمان' } }
    },
    tld: ['.om'],
    cca2: 'OM',
    ccn3: '512',
    cca3: 'OMN',
    cioc: 'OMA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { OMR: { name: 'Omani rial', symbol: 'ر.ع.' } },
    idd: { root: '+9', suffixes: ['68'] },
    capital: ['Muscat'],
    altSpellings: ['OM', 'Sultanate of Oman', 'Salṭanat ʻUmān'],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { ara: 'Arabic' },
    translations: {
      ara: { official: 'سلطنة عمان', common: 'عمان' },
      bre: { official: 'Sultanelezh Oman', common: 'Oman' },
      ces: { official: 'Sultanát Omán', common: 'Omán' },
      cym: { official: 'Sultanate of Oman', common: 'Oman' },
      deu: { official: 'Sultanat Oman', common: 'Oman' },
      est: { official: 'Omaani Sultaniriik', common: 'Omaan' },
      fin: { official: 'Omanin sulttaanikunta', common: 'Oman' },
      fra: { official: "Sultanat d'Oman", common: 'Oman' },
      hrv: { official: 'Sultanat Oman', common: 'Oman' },
      hun: { official: 'Ománi Szultanátus', common: 'Omán' },
      ita: { official: "Sultanato dell'Oman", common: 'oman' },
      jpn: { official: 'オマーン·スルタン国', common: 'オマーン' },
      kor: { official: '오만 술탄국', common: '오만' },
      nld: { official: 'Sultanaat van Oman', common: 'Oman' },
      per: { official: 'سلطان‌نشین عُمان', common: 'عمان' },
      pol: { official: 'Sułtanat Omanu', common: 'Oman' },
      por: { official: 'Sultanato de Omã', common: 'Omã' },
      rus: { official: 'Султанат Оман', common: 'Оман' },
      slk: { official: 'Ománsky sultanát', common: 'Omán' },
      spa: { official: 'Sultanato de Omán', common: 'Omán' },
      swe: { official: 'Sultanatet Oman', common: 'Oman' },
      tur: { official: 'Umman Sultanlığı', common: 'Umman' },
      urd: { official: 'سلطنت عمان', common: 'عمان' },
      zho: { official: '阿曼苏丹国', common: '阿曼' }
    },
    latlng: [21.0, 57.0],
    landlocked: false,
    borders: ['SAU', 'ARE', 'YEM'],
    area: 309500.0,
    demonyms: {
      eng: { f: 'Omani', m: 'Omani' },
      fra: { f: 'Omanaise', m: 'Omanais' }
    },
    flag: '\uD83C\uDDF4\uD83C\uDDF2',
    maps: {
      googleMaps: 'https://goo.gl/maps/L2BoXoAwDDwWecnw5',
      openStreetMaps: 'https://www.openstreetmap.org/relation/305138'
    },
    population: 5106622,
    fifa: 'OMA',
    car: { signs: ['OM'], side: 'right' },
    timezones: ['UTC+04:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/om.png',
      svg: 'https://flagcdn.com/om.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/om.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/om.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [23.62, 58.58] },
    postalCode: { format: '###', regex: '^(\\d{3})$' }
  },
  {
    name: {
      common: 'North Korea',
      official: "Democratic People's Republic of Korea",
      nativeName: {
        kor: { official: '조선민주주의인민공화국', common: '조선' }
      }
    },
    tld: ['.kp'],
    cca2: 'KP',
    ccn3: '408',
    cca3: 'PRK',
    cioc: 'PRK',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { KPW: { name: 'North Korean won', symbol: '₩' } },
    idd: { root: '+8', suffixes: ['50'] },
    capital: ['Pyongyang'],
    altSpellings: [
      'KP',
      "Democratic People's Republic of Korea",
      'DPRK',
      '조선민주주의인민공화국',
      'Chosŏn Minjujuŭi Inmin Konghwaguk',
      "Korea, Democratic People's Republic of",
      '북한',
      '북조선'
    ],
    region: 'Asia',
    subregion: 'Eastern Asia',
    languages: { kor: 'Korean' },
    translations: {
      ara: {
        official: 'جمهورية كوريا الديمقراطية الشعبية',
        common: 'كوريا الشمالية'
      },
      bre: {
        official: 'Republik Poblel ha Demokratel Korea',
        common: 'Korea an Norzh'
      },
      ces: {
        official: 'Korejská lidově demokratická republika',
        common: 'Severní Korea'
      },
      cym: {
        official: "Democratic People's Republic of Korea",
        common: 'North Korea'
      },
      deu: {
        official: 'Demokratische Volksrepublik Korea',
        common: 'Nordkorea'
      },
      est: {
        official: 'Korea Rahvademokraatlik Vabariik',
        common: 'Põhja-Korea'
      },
      fin: {
        official: 'Korean demokraattinen kansantasavalta',
        common: 'Pohjois-Korea'
      },
      fra: {
        official: 'République populaire démocratique de Corée',
        common: 'Corée du Nord'
      },
      hrv: {
        official: 'Demokratska Narodna Republika Koreja',
        common: 'Sjeverna Koreja'
      },
      hun: {
        official: 'Koreai Népi Demokratikus Köztársaság',
        common: 'Észak-Korea'
      },
      ita: {
        official: 'Repubblica democratica popolare di Corea',
        common: 'Corea del Nord'
      },
      jpn: {
        official: '朝鮮民主主義人民共和国',
        common: '朝鮮民主主義人民共和国'
      },
      kor: { official: '조선민주주의인민공화국', common: '조선' },
      nld: {
        official: 'Democratische Volksrepubliek Korea',
        common: 'Noord-Korea'
      },
      per: { official: 'جمهوری دموکراتیک خلق کره', common: 'کُره شمالی' },
      pol: {
        official: 'Koreańska Republika Ludowo-Demokratyczna',
        common: 'Korea Północna'
      },
      por: {
        official: 'República Popular Democrática da Coreia',
        common: 'Coreia do Norte'
      },
      rus: {
        official: 'Корейская Народно-Демократическая Республика Корея',
        common: 'Северная Корея'
      },
      slk: {
        official: 'Kórejská ľudovodemokratická republika',
        common: 'Kórejská ľudovodemokratická republika (KĽR, Severná Kórea)'
      },
      spa: {
        official: 'República Popular Democrática de Corea',
        common: 'Corea del Norte'
      },
      swe: {
        official: 'Demokratiska Folkrepubliken Korea',
        common: 'Nordkorea'
      },
      tur: {
        official: 'Kore Demokratik Halk Cumhuriyeti',
        common: 'Kuzey Kore'
      },
      urd: { official: 'جمہوری عوامی جمہوریہ کوریا', common: 'شمالی کوریا' },
      zho: { official: '朝鲜人民民主共和国', common: '朝鲜' }
    },
    latlng: [40.0, 127.0],
    landlocked: false,
    borders: ['CHN', 'KOR', 'RUS'],
    area: 120538.0,
    demonyms: {
      eng: { f: 'North Korean', m: 'North Korean' },
      fra: { f: 'Nord-coréenne', m: 'Nord-coréen' }
    },
    flag: '\uD83C\uDDF0\uD83C\uDDF5',
    maps: {
      googleMaps: 'https://goo.gl/maps/9q5T2DMeH5JL7Tky6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192734'
    },
    population: 25778815,
    fifa: 'PRK',
    car: { signs: [''], side: 'right' },
    timezones: ['UTC+09:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/kp.png',
      svg: 'https://flagcdn.com/kp.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/kp.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/kp.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [39.02, 125.75] },
    postalCode: { format: '###-###', regex: '^(\\d{6})$' }
  },
  {
    name: {
      common: 'Qatar',
      official: 'State of Qatar',
      nativeName: { ara: { official: 'دولة قطر', common: 'قطر' } }
    },
    tld: ['.qa', 'قطر.'],
    cca2: 'QA',
    ccn3: '634',
    cca3: 'QAT',
    cioc: 'QAT',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { QAR: { name: 'Qatari riyal', symbol: 'ر.ق' } },
    idd: { root: '+9', suffixes: ['74'] },
    capital: ['Doha'],
    altSpellings: ['QA', 'State of Qatar', 'Dawlat Qaṭar'],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { ara: 'Arabic' },
    translations: {
      ara: { official: 'دولة قطر', common: 'قطر' },
      bre: { official: 'Stad Katar', common: 'Katar' },
      ces: { official: 'Stát Katar', common: 'Katar' },
      cym: { official: 'State of Qatar', common: 'Qatar' },
      deu: { official: 'Staat Katar', common: 'Katar' },
      est: { official: 'Katari Riik', common: 'Katar' },
      fin: { official: 'Qatarin valtio', common: 'Qatar' },
      fra: { official: 'État du Qatar', common: 'Qatar' },
      hrv: { official: 'Država Katar', common: 'Katar' },
      hun: { official: 'Katari Állam', common: 'Katar' },
      ita: { official: 'Stato del Qatar', common: 'Qatar' },
      jpn: { official: 'カタール国', common: 'カタール' },
      kor: { official: '카타르국', common: '카타르' },
      nld: { official: 'Staat Qatar', common: 'Qatar' },
      per: { official: 'دولت قطر', common: 'قطر' },
      pol: { official: 'Państwo Katar', common: 'Katar' },
      por: { official: 'Estado do Qatar', common: 'Catar' },
      rus: { official: 'Государство Катар', common: 'Катар' },
      slk: { official: 'Katarský štát', common: 'Katar' },
      spa: { official: 'Estado de Qatar', common: 'Catar' },
      swe: { official: 'Staten Qatar', common: 'Qatar' },
      tur: { official: 'Katar Devleti', common: 'Katar' },
      urd: { official: 'ریاستِ قطر', common: 'قطر' },
      zho: { official: '卡塔尔国', common: '卡塔尔' }
    },
    latlng: [25.5, 51.25],
    landlocked: false,
    borders: ['SAU'],
    area: 11586.0,
    demonyms: {
      eng: { f: 'Qatari', m: 'Qatari' },
      fra: { f: 'Qatarienne', m: 'Qatarien' }
    },
    flag: '\uD83C\uDDF6\uD83C\uDDE6',
    maps: {
      googleMaps: 'https://goo.gl/maps/ZV76Y49z7LLUZ2KQ6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/305095'
    },
    population: 2881060,
    fifa: 'QAT',
    car: { signs: ['Q'], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/qa.png',
      svg: 'https://flagcdn.com/qa.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/qa.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/qa.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [25.28, 51.53] }
  },
  {
    name: {
      common: 'Bahrain',
      official: 'Kingdom of Bahrain',
      nativeName: { ara: { official: 'مملكة البحرين', common: '‏البحرين' } }
    },
    tld: ['.bh'],
    cca2: 'BH',
    ccn3: '048',
    cca3: 'BHR',
    cioc: 'BRN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { BHD: { name: 'Bahraini dinar', symbol: '.د.ب' } },
    idd: { root: '+9', suffixes: ['73'] },
    capital: ['Manama'],
    altSpellings: ['BH', 'Kingdom of Bahrain', 'Mamlakat al-Baḥrayn'],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { ara: 'Arabic' },
    translations: {
      ara: { official: 'مملكة البحرين', common: '‏البحرين' },
      bre: { official: 'Rouantelezh Bahrein', common: 'Bahrein' },
      ces: { official: 'Království Bahrajn', common: 'Bahrajn' },
      cym: { official: 'Teyrnas Bahrein', common: 'Bahrain' },
      deu: { official: 'Königreich Bahrain', common: 'Bahrain' },
      est: { official: 'Bahreini Kuningriik', common: 'Bahrein' },
      fin: { official: 'Bahrainin kuningaskunta', common: 'Bahrain' },
      fra: { official: 'Royaume de Bahreïn', common: 'Bahreïn' },
      hrv: { official: 'Kraljevina Bahrein', common: 'Bahrein' },
      hun: { official: 'Bahreini Királyság', common: 'Bahrein' },
      ita: { official: 'Regno del Bahrain', common: 'Bahrein' },
      jpn: { official: 'バーレーン王国', common: 'バーレーン' },
      kor: { official: '바레인 왕국', common: '바레인' },
      nld: { official: 'Koninkrijk Bahrein', common: 'Bahrein' },
      per: { official: 'پادشاهی بحرین', common: 'بحرین' },
      pol: { official: 'Królestwo Bahrajnu', common: 'Bahrajn' },
      por: { official: 'Reino do Bahrein', common: 'Bahrein' },
      rus: { official: 'Королевство Бахрейн', common: 'Бахрейн' },
      slk: { official: 'Bahrajnské kráľovstvo', common: 'Bahrajn' },
      spa: { official: 'Reino de Bahrein', common: 'Bahrein' },
      swe: { official: 'Konungariket Bahrain', common: 'Bahrain' },
      tur: { official: 'Bahreyn Krallığı', common: 'Bahreyn' },
      urd: { official: 'مملکتِ بحرین', common: 'بحرین' },
      zho: { official: '巴林王国', common: '巴林' }
    },
    latlng: [26.0, 50.55],
    landlocked: false,
    area: 765.0,
    demonyms: {
      eng: { f: 'Bahraini', m: 'Bahraini' },
      fra: { f: 'Bahreïnienne', m: 'Bahreïnien' }
    },
    flag: '\uD83C\uDDE7\uD83C\uDDED',
    maps: {
      googleMaps: 'https://goo.gl/maps/5Zue99Zc6vFBHxzJ7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/378734'
    },
    population: 1701583,
    fifa: 'BHR',
    car: { signs: ['BRN'], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/bh.png',
      svg: 'https://flagcdn.com/bh.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/bh.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/bh.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [26.23, 50.57] },
    postalCode: { format: '####|###', regex: '^(\\d{3}\\d?)$' }
  },
  {
    name: {
      common: 'Palestine',
      official: 'State of Palestine',
      nativeName: { ara: { official: 'دولة فلسطين', common: 'فلسطين' } }
    },
    tld: ['.ps', 'فلسطين.'],
    cca2: 'PS',
    ccn3: '275',
    cca3: 'PSE',
    cioc: 'PLE',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: {
      EGP: { name: 'Egyptian pound', symbol: 'E£' },
      ILS: { name: 'Israeli new shekel', symbol: '₪' },
      JOD: { name: 'Jordanian dinar', symbol: 'JD' }
    },
    idd: { root: '+9', suffixes: ['70'] },
    capital: ['Ramallah'],
    altSpellings: [
      'PS',
      'Palestine, State of',
      'State of Palestine',
      'Dawlat Filasṭin'
    ],
    region: 'Asia',
    subregion: 'Western Asia',
    languages: { ara: 'Arabic' },
    translations: {
      ara: { official: 'دولة فلسطين', common: 'فلسطين' },
      bre: { official: 'Stad Palestina', common: 'Palestina' },
      ces: { official: 'Stát Palestina', common: 'Palestina' },
      cym: { official: 'State of Palestine', common: 'Palestine' },
      deu: { official: 'Staat Palästina', common: 'Palästina' },
      est: { official: 'Palestiina Riik', common: 'Palestiina' },
      fin: { official: 'Palestiinan valtio', common: 'Palestiina' },
      fra: { official: 'État de Palestine', common: 'Palestine' },
      hrv: { official: 'State of Palestine', common: 'Palestina' },
      hun: { official: 'Palesztin Autonómia', common: 'Palesztina' },
      ita: { official: 'Stato di Palestina', common: 'Palestina' },
      jpn: { official: 'パレスチナ自治政府', common: 'パレスチナ' },
      kor: { official: '팔레스타인국', common: '팔레스타인' },
      nld: { official: 'Staat Palestina', common: 'Palestijnse gebieden' },
      per: { official: 'دولت فلسطین', common: 'فلسطین' },
      pol: { official: 'Państwo Palestyna', common: 'Palestyna' },
      por: { official: 'Estado da Palestina', common: 'Palestina' },
      rus: { official: 'Государство Палестина', common: 'Палестина' },
      slk: { official: 'Palestínsky štát', common: 'Palestína' },
      spa: { official: 'Estado de Palestina', common: 'Palestina' },
      swe: { official: 'Palestina', common: 'Palestina' },
      tur: { official: 'Filistin Devleti', common: 'Filistin' },
      urd: { official: 'ریاستِ فلسطین', common: 'فلسطین' },
      zho: { official: '巴勒斯坦国', common: '巴勒斯坦' }
    },
    latlng: [31.9, 35.2],
    landlocked: false,
    borders: ['ISR', 'EGY', 'JOR'],
    area: 6220.0,
    demonyms: {
      eng: { f: 'Palestinian', m: 'Palestinian' },
      fra: { f: 'Palestinienne', m: 'Palestinien' }
    },
    flag: '\uD83C\uDDF5\uD83C\uDDF8',
    maps: {
      googleMaps: 'https://goo.gl/maps/QvTbkRdmdWEoYAmt5',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1703814'
    },
    population: 4803269,
    gini: { 2016: 33.7 },
    fifa: 'PLE',
    car: { signs: ['PS'], side: 'right' },
    timezones: ['UTC+02:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/ps.png',
      svg: 'https://flagcdn.com/ps.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ps.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ps.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [31.9, 35.2] }
  }
]
